import React, {
  useState,
  useEffect,
  useRef,
  Suspense,
  useCallback,
  useMemo,
} from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Divider,
  Chip,
  Tooltip,
  Radio,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
  Accordion,
  AccordionActions,
  AccordionSummary,
  AccordionDetails,
  Menu,
  MenuItem,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  TextField,
  Button,
  Avatar,
  Stack,
  Grid,
  Breadcrumbs,
  Link,
  Switch,
  styled,
  List,
  ListItemSecondaryAction,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  alpha,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  Card,
  CardActionArea,
  CardContent,
} from "@mui/material";
import {
  ReviewsRounded as ReviewsRoundedIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  StarBorder as StarBorderIcon,
  GridViewRounded as GridViewRoundedIcon,
  RadioButtonCheckedRounded as RadioButtonCheckedRoundedIcon,
  AssignmentTurnedInRounded as AssignmentTurnedInRoundedIcon,
  FolderSpecialRounded as FolderSpecialRoundedIcon,
  AnnouncementRounded as AnnouncementRoundedIcon,
  Menu as MenuIcon,
  MenuOpenRounded as MenuOpenRoundedIcon,
  FilterAlt as FilterAltIcon,
  AccountBalance as AccountBalanceIcon,
  CreditCard as CreditCardIcon,
  Savings as SavingsIcon,
  ShoppingBag as ShoppingBagIcon,
  PointOfSale as PointOfSaleIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  OpenInNew as OpenInNewIcon,
  CloudCircle as CloudCircleIcon,
  Comment as CommentIcon,
  Send as SendIcon,
  FolderOpen as FolderOpenIcon,
  HistoryEdu as HistoryEduIcon,
  RadioButtonCheckedOutlined as RadioButtonCheckedOutlinedIcon,
  MarkChatUnreadOutlined as MarkChatUnreadOutlinedIcon,
  TimelineOutlined as TimelineOutlinedIcon,
  PostAddOutlined as PostAddOutlinedIcon,
  SpeakerNotesOutlined as SpeakerNotesOutlinedIcon,
  AccessTimeOutlined as AccessTimeOutlinedIcon,
  DownloadOutlined as DownloadOutlinedIcon,
  Pages as PagesIcon,
  TipsAndUpdates as TipsAndUpdatesIcon,
  LibraryBooks as LibraryBooksIcon,
  ChatBubbleOutline as ChatBubbleOutlineIcon,
  Close as CloseIcon,
  FormatQuote as FormatQuoteIcon,
  AccountCircle as AccountCircleIcon,
  Tag as TagIcon,
  PlayArrow as PlayArrowIcon,
  HourglassEmpty as HourglassEmptyIcon,
  CheckCircle as CheckCircleIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  Archive as ArchiveIcon,
  Assignment as AssignmentIcon,
  Description as DescriptionIcon,
  Image as ImageIcon,
  PictureAsPdf as PictureAsPdfIcon,
  TableChart as TableChartIcon,
  Article as ArticleIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Visibility as VisibilityIcon,
  Delete as DeleteIcon,
  ErrorOutline as ErrorOutlineIcon,
  Edit as EditIcon,
  StickyNote2 as StickyNote2Icon,
  AutoFixHigh as AutoFixHighIcon,
  Analytics as AnalyticsIcon,
  AutoAwesome as AutoAwesomeIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Search as SearchIcon,
  FindInPage as FindInPageIcon,
  FactCheck as FactCheckIcon,
} from "@mui/icons-material";
import { Editor } from "@tinymce/tinymce-react";
import IASideBar from "./IASideBar";
import ResponsiveContainer from "../../layout/Container";
import SearchAppBar from "../../common/Appbar";
import Separator from "../../layout/Separator";
import DynamicTabs from "../../common/DynamicTabs";
import NormalTextField from "../../common/NormalTextField";
import Modal from "../../common/Modal";
import MultipleSelect from "../../common/MultipleSelect";
import auditService from "../../../services/AuditService";
import appService from "../../../services/ApplicationService";
import { debounce } from "lodash";
import { reviewNotesService } from "../../../services/ReviewNotesService";
import userService from "../../../services/UserService";
import axios from "axios";
import DynamicSnackbar from "../../common/Snackbar";
import Snackbar from "@mui/material/Snackbar";
import AIDocumentationDialog from '../../common/AIDocumentationDialog';
import HRService from '../../../services/HrService';
import WorkpapersEvidence from '../../common/WorkpapersEvidence';
import roleService from '../../../services/RoleService';
import SignOffStatus from '../../common/SignOffStatus';
import WorkpaperExport from '../../common/WorkpaperExport';
 // Add to imports
 import WorkpaperAssignDialog from '../../common/WorkpaperAssignDialog';
// Utility functions
const getStatusColor = (status) => {
  return "#2196f3"; // Consistent blue color for all statuses
};

// Add this near other style declarations
const TestTypeChip = styled(Chip)(({ theme, selected }) => ({
  margin: theme.spacing(0.5),
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: selected ? theme.palette.primary.main : theme.palette.action.hover,
  },
  ...(selected && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
}));

// First, let's define a reusable test type component
const TestTypeSelector = ({ value, onChange, showIcons = false }) => {
  const testTypes = [
    { value: "Inquiry", icon: <QuestionAnswerIcon fontSize="small" /> },
    { value: "Observation", icon: <VisibilityIcon fontSize="small" /> },
    { value: "Inspection", icon: <SearchIcon fontSize="small" /> },
    { value: "Inquiry and Observation", icon: <FindInPageIcon fontSize="small" /> },
    { value: "Inquiry and Inspection", icon: <FactCheckIcon fontSize="small" /> }
  ];

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {testTypes.map((type) => (
        <TestTypeChip
          key={type.value}
          label={
            showIcons ? (
              <Stack direction="row" spacing={0.5} alignItems="center">
                {type.icon}
                <span>{type.value}</span>
              </Stack>
            ) : (
              type.value
            )
          }
          onClick={() => onChange(type.value)}
          selected={value === type.value}
          variant={value === type.value ? "filled" : "outlined"}
        />
      ))}
    </Box>
  );
};

const WorkpapersDetails = () => {
  // Route params
  const { id, app_id, controlref } = useParams();

  // Loading and UI states
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = React.useState(true);
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [expanded, setExpanded] = useState(true);
  const [expandedInterim, setExpandedInterim] = useState(true);
  const [expandedRF, setExpandedRF] = useState(true);
  const [expandedFinal, setExpandedFinal] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [modalTabValue, setModalTabValue] = useState("design");
  const [selectedControl, setSelectedControl] = useState(null);
  const [controlOptions, setControlOptions] = useState([]);

  // Add audit users state
  const [auditUsers, setAuditUsers] = useState([]);

  // Add tester and reviewer states for each phase
  const [designTester, setDesignTester] = useState("");
  const [designReviewer, setDesignReviewer] = useState("");
  const [interimTester, setInterimTester] = useState("");
  const [interimReviewer, setInterimReviewer] = useState("");
  const [rfTester, setRfTester] = useState("");
  const [rfReviewer, setRfReviewer] = useState("");
  const [finalTester, setFinalTester] = useState("");
  const [finalReviewer, setFinalReviewer] = useState("");

  // Add new state for modal procedures
  const [modalProceduresData, setModalProceduresData] = useState({
    DESIGN_PROCEDURES: "",
    INTERIM_PROCEDURES: "",
    ROLLFORWARD_PROCEDURES: "",
    FINAL_PROCEDURES: "",
  });

  // Add state for procedures data
  const [proceduresData, setProceduresData] = useState([]);

  // Design Evidence states
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const fileInputRef = React.useRef(null);
  const [dragActive, setDragActive] = useState(false);

  // Interim Evidence states
  const [interimFiles, setInterimFiles] = useState([]);
  const interimFileInputRef = React.useRef(null);
  const [interimDragActive, setInterimDragActive] = useState(false);

  // RF Evidence states
  const [rfFiles, setRfFiles] = useState([]);
  const rfFileInputRef = React.useRef(null);
  const [rfDragActive, setRfDragActive] = useState(false);

  // Final Evidence states
  const [finalFiles, setFinalFiles] = useState([]);
  const finalFileInputRef = React.useRef(null);
  const [finalDragActive, setFinalDragActive] = useState(false);

  const [token, setToken] = useState(localStorage.getItem("token") || "");

  // Add new state for evidence files
  const [evidenceFiles, setEvidenceFiles] = useState([]);
  const evidenceFileInputRef = React.useRef(null);
  const [evidenceDragActive, setEvidenceDragActive] = useState(false);

  // Status management
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const [workpaperStatus, setWorkpaperStatus] = useState("");
  const [designProcedureType, setDesignProcedureType] = useState("");
  const [interimProcedureType, setInterimProcedureType] = useState("");
  const [rfProcedureType, setRfProcedureType] = useState("");
  const [finalProcedureType, setFinalProcedureType] = useState("");
  const [interimApplicable, setInterimApplicable] = useState("Yes");
  const [rfApplicable, setRfApplicable] = useState("Yes");
  const [finalApplicable, setFinalApplicable] = useState("Yes");

  // Add these state variables inside the WorkpapersDetails component
  const [openAIDialog, setOpenAIDialog] = useState(false);
  const [processOwners, setProcessOwners] = useState([]);
  const [dateOfInquiry, setDateOfInquiry] = useState('');
  const [policyAvailable, setPolicyAvailable] = useState('');
  const [evidenceReviewed, setEvidenceReviewed] = useState('');
  const [evidenceSufficient, setEvidenceSufficient] = useState('');

  // Add new state for evidence types
  const [evidenceTypes, setEvidenceTypes] = useState([]);
  const [evidenceDetails, setEvidenceDetails] = useState('');

  // Add these new state variables after the other state declarations
  const [sampleReviewed, setSampleReviewed] = useState('No');
  const [sampleCount, setSampleCount] = useState('');

  const [signOffDialogOpen, setSignOffDialogOpen] = useState(false);
  const [signOffRole, setSignOffRole] = useState('');
  const [signOffDate, setSignOffDate] = useState(new Date().toISOString().split('T')[0]);
  const [signOffPhase, setSignOffPhase] = useState('');

  // Add these handler functions
  const handleOpenAIDialog = () => {
    setOpenAIDialog(true);
  };

  const handleCloseAIDialog = () => {
    setOpenAIDialog(false);
  };

  const handleSubmitAIDialog = async () => {
    try {
      setIsGenerating(true);
      
      const documentationData = {
        control_title: testingInfo?.CONTROL_DETAILS?.CONTROL_TITLE,
        process_owners: processOwners.map(owner => owner.label).join(', '),
        date_of_inquiry: dateOfInquiry,
        policy_available: policyAvailable,
        evidence_types: evidenceTypes.map(type => type.label),
        design_description: evidenceDetails,
        sample_reviewed: sampleReviewed,
        sample_count: sampleReviewed === 'Yes' ? sampleCount : null,
        evidence_sufficient: evidenceSufficient,
        workpaper_id: workpaperID  // Add workpaper ID to the request
      };

      const response = await auditService.generateDesignDocumentation(documentationData);
      
      if (response.documentation) {
        setDesignResult(response.documentation);
        await handleWorkpaperSave(response.documentation, 'designResult');
        setSnackbarMessage('Design documentation generated successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setOpenAIDialog(false);
      }
    } catch (error) {
      console.error('Error generating design documentation:', error);
      setSnackbarMessage('Error generating design documentation');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setIsGenerating(false);
    }
  };

  const statusOptions = [
    "Not Started",
    "In Progress",
    "In Review",
    "Complete",
    "Archived",
  ];

  const getStatusIcon = (status, color = null) => {
    const iconColor =
      color || (workpaperStatus === status ? "#2196f3" : "#757575");
    switch (status) {
      case "Not Started":
        return <PlayArrowIcon sx={{ color: iconColor }} />;
      case "In Progress":
        return <HourglassEmptyIcon sx={{ color: iconColor }} />;
      case "In Review":
        return <AssignmentIcon sx={{ color: iconColor }} />;
      case "Complete":
        return <CheckCircleIcon sx={{ color: iconColor }} />;
      case "Archived":
        return <ArchiveIcon sx={{ color: iconColor }} />;
      default:
        return <PlayArrowIcon sx={{ color: iconColor }} />;
    }
  };

  // Project and app data
  const [selectedProject, setSelectedProject] = useState([]);
  const [selectedApp, setSelectedApp] = useState([]);
  const [apps, setApps] = useState([]);
  const [companyID, setCompanyID] = useState([]);
  const [appID, setAppID] = useState([]);

  // Workpaper and testing data
  const [workpapers, setWorkpapers] = useState([]);
  const [workpaperID, setWorkpaperID] = useState("");
  const [testingInfo, setTestingInfo] = useState([]);
  const [designProcedure, setDesignProcedure] = useState("");
  const [interimProcedure, setInterimProcedure] = useState("");
  const [designResult, setDesignResult] = useState("");
  const [designConclusion, setDesignConclusion] = useState("");
  const [designConclusionRationale, setDesignConclusionRationale] =
    useState("");
  const [interimResult, setInterimResult] = useState("");
  const [interimConclusion, setInterimConclusion] = useState("");
  const [interimConclusionRationale, setInterimConclusionRationale] =
    useState("");
  const [workpaperDetails, setWorkpaperDetails] = useState([]);
  const [workpaperDetailsExisting, setWorkpaperDetailsExisting] =
    useState(false);

  // Procedure management
  const [procedureOptions, setProcedureOptions] = useState([]);
  const [selectedPhase, setSelectedPhase] = useState([]);
  const [selectedProcedureName, setSelectedProcedureName] = useState([]);
  const [selectedProcedures, setSelectedProcedures] = useState([]);

  // Review notes management

  const [newNote, setNewNote] = useState("");
  const [highlightedText, setHighlightedText] = useState(null);
  const [highlightedNote, setHighlightedNote] = useState(null);
  const [noteCategory, setNoteCategory] = useState("normal"); // 'urgent', 'normal', 'todo'
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState("");

  // Add this near the top with other state declarations
  const [isSaving, setIsSaving] = useState(false);

  // Add new state variables after the existing ones
  const [rfProcedure, setRfProcedure] = useState("");
  const [rfResult, setRfResult] = useState("");
  const [rfConclusion, setRfConclusion] = useState("");
  const [rfConclusionRationale, setRfConclusionRationale] = useState("");

  const [finalProcedure, setFinalProcedure] = useState("");
  const [finalResult, setFinalResult] = useState("");
  const [finalConclusion, setFinalConclusion] = useState("");
  const [finalConclusionRationale, setFinalConclusionRationale] = useState("");
  const [currentUser, setCurrentUser] = useState(null);

  // Add deficiency details state variables
  const [dateIdentified, setDateIdentified] = useState("");
  const [rootCause, setRootCause] = useState("");
  const [managementActionPlan, setManagementActionPlan] = useState("");
  const [remediationOwner, setRemediationOwner] = useState("");
  const [remediationStatus, setRemediationStatus] = useState("Unremediated");
  const [dateClosed, setDateClosed] = useState("");
  const [mitigatingControls, setMitigatingControls] = useState("");
  const [deficiencyType, setDeficiencyType] = useState("");
  const [deficiencyDescription, setDeficiencyDescription] = useState("");

  const [isGenerating, setIsGenerating] = useState(false);
  const [generationError, setGenerationError] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showGenerateConfirmation, setShowGenerateConfirmation] =
    useState(false);

      // Add these state variables after other state declarations
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [isAssigning, setIsAssigning] = useState(false);

  // Add this function before the render
  const handleAssignWorkpaper = async (assigneeEmail) => {
    try {
      setIsAssigning(true);
      
      const data = {
        AUDIT_FILE: testingInfo.id,
        ASSIGNED_TO: assigneeEmail
      };

      if (workpaperDetailsExisting) {
        await auditService.updateWorkpaperDetails(workpaperID, data);
      } 

      setTestingInfo(prev => ({
        ...prev,
        ASSIGNED_TO: assigneeEmail
      }));

      const updatedDetails = await auditService.fetchWorkpaperDetailsById(testingInfo.id);
      if (updatedDetails && updatedDetails.length > 0) {
        setWorkpaperDetails(updatedDetails);
      }

      setSnackbarMessage('Workpaper assigned successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      setAssignDialogOpen(false);
    } catch (error) {
      setSnackbarMessage('Error assigning workpaper: ' + (error.message || 'Unknown error'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setIsAssigning(false);
    }
  };

  //Add the analysis

  // Add these state declarations near the top with other useState declarations
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [showAnalysisModal, setShowAnalysisModal] = useState(false);
  const [showReviewNotes, setShowReviewNotes] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [reviewNotes, setReviewNotes] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);

    const getSignOffIcons = (phase) => {
    const testerName = workpaperDetails?.[0]?.[`${phase}_TESTER`];
    const reviewerName = workpaperDetails?.[0]?.[`${phase}_REVIEWER`];
    const testerDate = workpaperDetails?.[0]?.[`${phase}_TESTER_SIGNOFF`];
    const reviewerDate = workpaperDetails?.[0]?.[`${phase}_REVIEWER_SIGNOFF`];
    
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        {testerName && (
          <Tooltip title={`Tested by: ${testerName}${testerDate ? `\nDate: ${new Date(testerDate).toLocaleDateString()}` : ''}`}>
            <Avatar
              sx={{ 
                width: 24, 
                height: 24, 
                fontSize: '0.75rem',
                bgcolor: 'primary.main' 
              }}
            >
              {getInitials(testerName)}
            </Avatar>
          </Tooltip>
        )}
        {reviewerName && (
          <Tooltip title={`Reviewed by: ${reviewerName}${reviewerDate ? `\nDate: ${new Date(reviewerDate).toLocaleDateString()}` : ''}`}>
            <Avatar
              sx={{ 
                width: 24, 
                height: 24, 
                fontSize: '0.75rem',
                bgcolor: 'secondary.main' 
              }}
            >
              {getInitials(reviewerName)}
            </Avatar>
          </Tooltip>
        )}
      </Stack>
    );
  };

  // Add this after the other state declarations
  const handleInterimChange = (event, isExpanded) => {
    setExpandedInterim(isExpanded);
  };

  const handleRFChange = (event, isExpanded) => {
    setExpandedRF(isExpanded);
  };

  const handleFinalChange = (event, isExpanded) => {
    setExpandedFinal(isExpanded);
  };

  // Add this near the top with other state declarations
  const [isLoadingNotes, setIsLoadingNotes] = useState(false);

  // Add this useEffect to fetch notes when component mounts
  useEffect(() => {
    const fetchReviewNotes = async () => {
      if (workpaperID) {
        setIsLoadingNotes(true);
        try {
          const notes = await reviewNotesService.getReviewNotes(workpaperID);

          // Create a map of parent notes and their replies
          const notesMap = {};
          const topLevelNotes = [];

          // First pass: Create a map of all notes
          notes.forEach((note) => {
            notesMap[note.id] = { ...note, replies: [] };
          });

          // Second pass: Structure the hierarchy
          notes.forEach((note) => {
            if (note.parent) {
              // This is a reply, add it to its parent's replies array
              if (notesMap[note.parent]) {
                notesMap[note.parent].replies.push(notesMap[note.id]);
              }
            } else {
              // This is a top-level note
              topLevelNotes.push(notesMap[note.id]);
            }
          });

          setReviewNotes(topLevelNotes);
        } catch (error) {
          console.error("Error fetching review notes:", error);
          setReviewNotes([]);
        } finally {
          setIsLoadingNotes(false);
        }
      }
    };

  const fetchCurrentUser = async () => {
      const currentUser = await userService.fetchCurrentUser();
      if (currentUser) {
        setCurrentUser(currentUser);
      }
    };

    fetchReviewNotes();
    fetchCurrentUser();
  }, [workpaperID]);

  const handleCategoryChange = async (noteId) => {
    try {
      const note = reviewNotes.find((n) => n.id === noteId);
      if (!note) return;

      const categories = ["urgent", "normal", "todo"];
      const currentIndex = categories.indexOf(note.category);
      const nextCategory = categories[(currentIndex + 1) % categories.length];

      const updatedNote = await reviewNotesService.updateNoteCategory(
        noteId,
        nextCategory
      );
      setReviewNotes((prev) =>
        prev.map((n) => (n.id === noteId ? updatedNote : n))
      );
    } catch (error) {
      console.error("Error updating note category:", error);
    }
  };

  const handleResolveNote = async (noteId) => {
    try {
      const note = reviewNotes.find((n) => n.id === noteId);
      if (!note) return;

      const updatedNote = await reviewNotesService.toggleNoteResolved(noteId);
      setReviewNotes((prev) =>
        prev.map((n) => (n.id === noteId ? updatedNote : n))
      );
    } catch (error) {
      console.error("Error toggling note resolved status:", error);
    }
  };

  const handleDeleteNote = async (noteId) => {
    try {
      await reviewNotesService.deleteReviewNote(noteId);
      setReviewNotes((prev) => prev.filter((n) => n.id !== noteId));
    } catch (error) {
      console.error("Error deleting note:", error);
    }
  };

  // Add shared save function before file handling functions
  const handleWorkpaperSave = async (newValue, field) => {
    let data = {
      AUDIT_FILE: testingInfo.id,
    };

    switch (field) {
      case "designProcedure":
        setDesignProcedure(newValue);
        data.DESIGN_PROCEDURES = newValue;
        break;
      case "designResult":
        setDesignResult(newValue);
        data.DESIGN_RESULT = newValue;
        break;
      case "designConclusion":
        setDesignConclusion(newValue);
        data.DESIGN_CONCLUSION = newValue;
        break;
      case "designConclusionRationale":
        setDesignConclusionRationale(newValue);
        data.DESIGN_CONCLUSION_RATIONALE = newValue;
        break;
      case "dateIdentified":
        setDateIdentified(newValue);
        data.DATE_IDENTIFIED = newValue;
        break;
      case "rootCause":
        setRootCause(newValue);
        data.ROOT_CAUSE = newValue;
        break;
      case "managementActionPlan":
        setManagementActionPlan(newValue);
        data.MANAGEMENT_ACTION_PLAN = newValue;
        break;
      case "remediationOwner":
        setRemediationOwner(newValue);
        data.REMEDIATION_OWNER = newValue;
        break;
      case "remediationStatus":
        setRemediationStatus(newValue);
        data.REMEDIATION_STATUS = newValue;
        break;
      case "date_closed":
        setDateClosed(newValue);
        data.DATE_REMEDIATED = newValue;  // Changed from DATE_CLOSED to DATE_REMEDIATED
        break;
      case "mitigatingControls":
        setMitigatingControls(newValue);
        data.MITIGATING_CONTROLS = newValue;
        break;
      case "interimProcedure":
        setInterimProcedure(newValue);
        data.INTERIM_PROCEDURES = newValue;
        break;
      case "interimResult":
        setInterimResult(newValue);
        data.INTERIM_RESULT = newValue;
        break;
      case "interimConclusion":
        setInterimConclusion(newValue);
        data.INTERIM_CONCLUSION = newValue;
        break;
      case "interimConclusionRationale":
        setInterimConclusionRationale(newValue);
        data.INTERIM_CONCLUSION_RATIONALE = newValue;
        break;
      case "rfProcedure":
        setRfProcedure(newValue);
        data.RF_PROCEDURES = newValue;
        break;
      case "rfResult":
        setRfResult(newValue);
        data.RF_RESULT = newValue;
        break;
      case "rfConclusion":
        setRfConclusion(newValue);
        data.RF_CONCLUSION = newValue;
        break;
      case "rfConclusionRationale":
        setRfConclusionRationale(newValue);
        data.RF_CONCLUSION_RATIONALE = newValue;
        break;
      case "finalProcedure":
        setFinalProcedure(newValue);
        data.FINAL_PROCEDURES = newValue;
        break;
      case "finalResult":
        setFinalResult(newValue);
        data.FINAL_RESULT = newValue;
        break;
      case "finalConclusion":
        setFinalConclusion(newValue);
        data.FINAL_CONCLUSION = newValue;
        break;
      case "finalConclusionRationale":
        setFinalConclusionRationale(newValue);
        data.FINAL_CONCLUSION_RATIONALE = newValue;
        break;
      case "rfConclusion": // Changed from rollforwardConclusion
        setRfConclusion(newValue);
        data.RF_CONCLUSION = newValue;
        break;
      case "designProcedureType":
        setDesignProcedureType(newValue);
        data.DESIGN_PROCEDURES_TYPE = newValue;
        break;
      case "interimProcedureType":
        setInterimProcedureType(newValue);
        data.INTERIM_PROCEDURES_TYPE = newValue;
        break;
      case "rfProcedureType":
        setRfProcedureType(newValue);
        data.RF_PROCEDURES_TYPE = newValue;
        break;
      case "finalProcedureType":
        setFinalProcedureType(newValue);
        data.FINAL_PROCEDURES_TYPE = newValue;
        break;
      case "interimPopulation":
        data.INTERIM_POPULATION = newValue;
        break;
      case "interimPopulationRationale":
        data.INTERIM_POPULATION_RATIONALE = newValue;
        break;
      case "interimSamples":
        data.INTERIM_SAMPLES = newValue;
        break;
      case "interimSamplingRationale":
        data.INTERIM_SAMPLING_RATIONALE = newValue;
        break;
      case "rfPopulation":
        data.RF_POPULATION = newValue;
        break;
      case "rfPopulationRationale":
        data.RF_POPULATION_RATIONALE = newValue;
        break;
      case "rfSamples":
        data.RF_SAMPLES = newValue;
        break;
      case "rfSamplingRationale":
        data.RF_SAMPLING_RATIONALE = newValue;
        break;
      case "finalPopulation":
        data.FINAL_POPULATION = newValue;
        break;
      case "finalPopulationRationale":
        data.FINAL_POPULATION_RATIONALE = newValue;
        break;
      case "finalSamples":
        data.FINAL_SAMPLES = newValue;
        break;
      case "finalSamplingRationale":
        data.FINAL_SAMPLING_RATIONALE = newValue;
        break;
      case "rollforwardPopulation":
        data.ROLLFORWARD_POPULATION = newValue;
        break;
      case "rollforwardSamples":
        data.ROLLFORWARD_SAMPLES = newValue;
        break;
      case "deficiency_type":
        setDeficiencyType(newValue);
        data.DEFICIENCY_TYPE = newValue;
        break;
      case "deficiency_description":
        setDeficiencyDescription(newValue);
        data.DEFICIENCY_DESCRIPTION = newValue;
        break;
      case "date_identified":
        setDateIdentified(newValue);
        data.DATE_IDENTIFIED = newValue;
        break;
      case "root_cause":
        setRootCause(newValue);
        data.ROOT_CAUSE = newValue;
        break;
      case "management_action_plan":
        setManagementActionPlan(newValue);
        data.MANAGEMENT_ACTION_PLAN = newValue;
        break;
      case "remediation_owner":
        setRemediationOwner(newValue);
        data.REMEDIATION_OWNER = newValue;
        break;
      case "remediation_status":
        setRemediationStatus(newValue);
        data.REMEDIATION_STATUS = newValue;
        break;
      case "date_closed":
        setDateClosed(newValue);
        data.DATE_REMEDIATED = newValue;  // Changed from DATE_CLOSED to DATE_REMEDIATED
        break;
      case "mitigating_controls":
        setMitigatingControls(newValue);
        data.MITIGATING_CONTROLS = newValue;
        break;
      default:
        return;
    }

    try {
      if (workpaperDetailsExisting) {
        await auditService.updateWorkpaperDetails(workpaperID, data);
      } 
      
    } catch (error) {
      console.error("Error saving workpaper details:", error);
    }
  };

  // File handling functions
  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // Add visual feedback
    event.currentTarget.style.borderColor = "#2196f3";
    event.currentTarget.style.backgroundColor = "#f5f5f5";
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    // Reset visual feedback
    event.currentTarget.style.borderColor = "#bdbdbd";
    event.currentTarget.style.backgroundColor = "#fafafa";
    setDragActive(false);
  };

  const handleFiles = async (files) => {
    const fileArray = Array.from(files);

    try {
      if (!fileArray.length) {
        console.error("No files to upload");
        return;
      }

      const formData = new FormData();
      fileArray.forEach((file) => {
        formData.append("files", file);
      });

      let currentWorkpaperId = workpaperID;

      if (!workpaperDetailsExisting) {
        const data = {
          AUDIT_FILE: testingInfo.id,
          DESIGN_PROCEDURES: designProcedure || "",
          DESIGN_RESULT: designResult || "",
          DESIGN_CONCLUSION: designConclusion || "",
          DESIGN_CONCLUSION_RATIONALE: "",
        };

        
      }

      const response = await auditService.uploadDesignEvidence(
        currentWorkpaperId,
        formData
      );

      if (response.successful_uploads) {
        const processedFiles = response.successful_uploads.map(
          (uploadedFile) => ({
            id: uploadedFile.id,
            original_filename: uploadedFile.filename,
            name: uploadedFile.filename,
            file_name: uploadedFile.file_name || uploadedFile.filename,
            url: uploadedFile.file_name
              ? `${process.env.REACT_APP_API_URL}/media/${uploadedFile.file_name}`
              : null,
          })
        );

        setUploadedFiles((prevFiles) => {
          const newFiles = [...prevFiles];
          processedFiles.forEach((newFile) => {
            if (
              !newFiles.some((existingFile) => existingFile.id === newFile.id)
            ) {
              newFiles.push(newFile);
            }
          });
          return newFiles;
        });
      }

      if (response.failed_uploads && response.failed_uploads.length > 0) {
        console.error("Some files failed to upload:", response.failed_uploads);
      }
    } catch (error) {
      console.error("Error handling files:", error);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setDragActive(false);

    // Reset visual feedback
    event.currentTarget.style.borderColor = "#bdbdbd";
    event.currentTarget.style.backgroundColor = "#fafafa";

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      handleFiles(event.dataTransfer.files);
    }
  };

  const handleFileSelect = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      handleFiles(event.target.files);
      // Reset the input
      event.target.value = "";
    }
  };

  const handleRemoveFile = async (fileId) => {
    try {
      if (fileId) {
        await auditService.deleteDesignEvidence(fileId);
        setUploadedFiles((prevFiles) =>
          prevFiles.filter((file) => file.id !== fileId)
        );
      }
    } catch (error) {
      console.error("Error removing file:", error);
    }
  };

  // Interim Evidence Handlers
  const handleInterimFiles = async (files) => {
    const fileArray = Array.from(files);

    try {
      if (!fileArray.length) {
        console.error("No files to upload");
        return;
      }

      const formData = new FormData();
      fileArray.forEach((file) => {
        formData.append("files", file);
      });

      let currentWorkpaperId = workpaperID;

      if (!workpaperDetailsExisting) {
        const data = {
          AUDIT_FILE: testingInfo.id,
          DESIGN_PROCEDURES: designProcedure || "",
          DESIGN_RESULT: designResult || "",
          DESIGN_CONCLUSION: designConclusion || "",
          DESIGN_CONCLUSION_RATIONALE: "",
        };

        
      }

      const response = await auditService.uploadInterimEvidence(
        currentWorkpaperId,
        formData
      );
      console.log("Upload response:", response);

      if (response.successful_uploads) {
        const processedFiles = response.successful_uploads.map(
          (uploadedFile) => ({
            id: uploadedFile.id,
            original_filename: uploadedFile.filename,
            name: uploadedFile.filename,
            file_name: uploadedFile.file_name || uploadedFile.filename,
            url: uploadedFile.file_name
              ? `${process.env.REACT_APP_API_URL}/media/${uploadedFile.file_name}`
              : null,
          })
        );

        setInterimFiles((prevFiles) => {
          const newFiles = [...prevFiles];
          processedFiles.forEach((newFile) => {
            if (
              !newFiles.some((existingFile) => existingFile.id === newFile.id)
            ) {
              newFiles.push(newFile);
            }
          });
          return newFiles;
        });
      }

      if (response.failed_uploads && response.failed_uploads.length > 0) {
        console.error("Some files failed to upload:", response.failed_uploads);
      }
    } catch (error) {
      console.error("Error handling interim files:", error);
    }
  };

  const handleInterimDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setInterimDragActive(false);

    event.currentTarget.style.borderColor = "#bdbdbd";
    event.currentTarget.style.backgroundColor = "#fafafa";

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      handleInterimFiles(event.dataTransfer.files);
    }
  };

  const handleInterimFileSelect = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      handleInterimFiles(event.target.files);
      event.target.value = "";
    }
  };

  const handleRemoveInterimFile = async (fileId) => {
    try {
      if (fileId) {
        await auditService.deleteInterimEvidence(fileId);
        setInterimFiles((prevFiles) =>
          prevFiles.filter((file) => file.id !== fileId)
        );
      }
    } catch (error) {
      console.error("Error removing interim file:", error);
    }
  };

  // RF Evidence Handlers
  const handleRFFiles = async (files) => {
    const fileArray = Array.from(files);

    try {
      if (!fileArray.length) {
        console.error("No files to upload");
        return;
      }

      const formData = new FormData();
      fileArray.forEach((file) => {
        formData.append("files", file);
      });

      let currentWorkpaperId = workpaperID;

      if (!workpaperDetailsExisting) {
        const data = {
          AUDIT_FILE: testingInfo.id,
          DESIGN_PROCEDURES: designProcedure || "",
          DESIGN_RESULT: designResult || "",
          DESIGN_CONCLUSION: designConclusion || "",
          DESIGN_CONCLUSION_RATIONALE: "",
        };

        
      }

      const response = await auditService.uploadRFEvidence(
        currentWorkpaperId,
        formData
      );
      console.log("Upload response:", response);

      if (response.successful_uploads) {
        const processedFiles = response.successful_uploads.map(
          (uploadedFile) => ({
            id: uploadedFile.id,
            original_filename: uploadedFile.filename,
            name: uploadedFile.filename,
            file_name: uploadedFile.file_name || uploadedFile.filename,
            url: uploadedFile.file_name
              ? `${process.env.REACT_APP_API_URL}/media/${uploadedFile.file_name}`
              : null,
          })
        );

        setRfFiles((prevFiles) => {
          const newFiles = [...prevFiles];
          processedFiles.forEach((newFile) => {
            if (
              !newFiles.some((existingFile) => existingFile.id === newFile.id)
            ) {
              newFiles.push(newFile);
            }
          });
          return newFiles;
        });
      }

      if (response.failed_uploads && response.failed_uploads.length > 0) {
        console.error("Some files failed to upload:", response.failed_uploads);
      }
    } catch (error) {
      console.error("Error handling RF files:", error);
    }
  };

  const handleRFDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setRfDragActive(false);

    event.currentTarget.style.borderColor = "#bdbdbd";
    event.currentTarget.style.backgroundColor = "#fafafa";

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      handleRFFiles(event.dataTransfer.files);
    }
  };

  const handleRFFileSelect = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      handleRFFiles(event.target.files);
      event.target.value = "";
    }
  };

  const handleRemoveRFFile = async (fileId) => {
    try {
      if (fileId) {
        await auditService.deleteRFEvidence(fileId);
        setRfFiles((prevFiles) =>
          prevFiles.filter((file) => file.id !== fileId)
        );
      }
    } catch (error) {
      console.error("Error removing RF file:", error);
    }
  };

  // Final Evidence Handlers
  const handleFinalFiles = async (files) => {
    const fileArray = Array.from(files);

    try {
      if (!fileArray.length) {
        console.error("No files to upload");
        return;
      }

      const formData = new FormData();
      fileArray.forEach((file) => {
        formData.append("files", file);
      });

      let currentWorkpaperId = workpaperID;

      if (!workpaperDetailsExisting) {
        const data = {
          AUDIT_FILE: testingInfo.id,
          DESIGN_PROCEDURES: designProcedure || "",
          DESIGN_RESULT: designResult || "",
          DESIGN_CONCLUSION: designConclusion || "",
          DESIGN_CONCLUSION_RATIONALE: "",
        };

       
      }

      const response = await auditService.uploadFinalEvidence(
        currentWorkpaperId,
        formData
      );
      console.log("Upload response:", response);

      if (response.successful_uploads) {
        const processedFiles = response.successful_uploads.map(
          (uploadedFile) => ({
            id: uploadedFile.id,
            original_filename: uploadedFile.filename,
            name: uploadedFile.filename,
            file_name: uploadedFile.file_name || uploadedFile.filename,
            url: uploadedFile.file_name
              ? `${process.env.REACT_APP_API_URL}/media/${uploadedFile.file_name}`
              : null,
          })
        );

        setFinalFiles((prevFiles) => {
          const newFiles = [...prevFiles];
          processedFiles.forEach((newFile) => {
            if (
              !newFiles.some((existingFile) => existingFile.id === newFile.id)
            ) {
              newFiles.push(newFile);
            }
          });
          return newFiles;
        });
      }

      if (response.failed_uploads && response.failed_uploads.length > 0) {
        console.error("Some files failed to upload:", response.failed_uploads);
      }
    } catch (error) {
      console.error("Error handling final files:", error);
    }
  };

  const handleFinalDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setFinalDragActive(false);

    event.currentTarget.style.borderColor = "#bdbdbd";
    event.currentTarget.style.backgroundColor = "#fafafa";

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      handleFinalFiles(event.dataTransfer.files);
    }
  };

  const handleFinalFileSelect = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      handleFinalFiles(event.target.files);
      event.target.value = "";
    }
  };

  const handleRemoveFinalFile = async (fileId) => {
    try {
      if (fileId) {
        await auditService.deleteFinalEvidence(fileId);
        setFinalFiles((prevFiles) =>
          prevFiles.filter((file) => file.id !== fileId)
        );
      }
    } catch (error) {
      console.error("Error removing final file:", error);
    }
  };

  const handleFileView = (file) => {
    const fileUrl =
      file.url ||
      (file.file_name
        ? `${process.env.REACT_APP_API_URL}/media/${file.file_name}`
        : null);
    if (!fileUrl) {
      console.error("No URL available for file:", file);
      return;
    }
    window.open(fileUrl, "_blank");
  };

  // Add evidence file handlers
  const handleEvidenceDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.style.borderColor = "#2196f3";
    event.currentTarget.style.backgroundColor = "#f5f5f5";
  };

  const handleEvidenceDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setEvidenceDragActive(true);
  };

  const handleEvidenceDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.style.borderColor = "#bdbdbd";
    event.currentTarget.style.backgroundColor = "#fafafa";
    setEvidenceDragActive(false);
  };

  const handleEvidenceDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setEvidenceDragActive(false);

    event.currentTarget.style.borderColor = "#bdbdbd";
    event.currentTarget.style.backgroundColor = "#fafafa";

    if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      handleEvidenceFiles(event.dataTransfer.files);
    }
  };

  const handleEvidenceFileSelect = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      handleEvidenceFiles(event.target.files);
      event.target.value = ""; // Reset the input
    }
  };

  const handleEvidenceFiles = async (files) => {
    const fileArray = Array.from(files);
    console.log("Starting evidence file upload process with files:", fileArray);

    try {
      if (!fileArray.length) {
        console.error("No files to upload");
        return;
      }

      const formData = new FormData();
      fileArray.forEach((file) => {
        formData.append("files[]", file);
      });

      // Here you would typically make an API call to upload the files
      // For now, we'll just add them to the state
      const newFiles = fileArray.map((file) => ({
        id: Date.now() + Math.random(),
        name: file.name,
        size: file.size,
        type: file.type,
      }));

      setEvidenceFiles((prevFiles) => [...prevFiles, ...newFiles]);
    } catch (error) {
      console.error("Error handling evidence files:", error);
    }
  };

  const handleRemoveEvidenceFile = (fileId) => {
    setEvidenceFiles((prevFiles) =>
      prevFiles.filter((file) => file.id !== fileId)
    );
  };

  // Function to get appropriate icon for file type
  const getFileIcon = (fileName) => {
    if (!fileName) return <InsertDriveFileIcon sx={{ color: "#757575" }} />;
    const name =
      typeof fileName === "string"
        ? fileName
        : fileName.original_filename || fileName.name;
    const extension = name.split(".").pop().toLowerCase();

    switch (extension) {
      case "pdf":
        return <PictureAsPdfIcon sx={{ color: "#ff5252" }} />;
      case "doc":
      case "docx":
        return <DescriptionIcon sx={{ color: "#2196f3" }} />;
      case "xls":
      case "xlsx":
      case "csv":
        return <TableChartIcon sx={{ color: "#4caf50" }} />;
      case "jpg":
      case "jpeg":
      case "png":
        return <ImageIcon sx={{ color: "#ff9800" }} />;
      case "txt":
        return <ArticleIcon sx={{ color: "#757575" }} />;
      default:
        return <InsertDriveFileIcon sx={{ color: "#757575" }} />;
    }
  };

  const handleStatusClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };

  const handleStatusClose = () => {
    setStatusAnchorEl(null);
  };

  const handleStatusChange = async (status) => {
    setWorkpaperStatus(status);
    handleStatusClose();

    const updatedData = {
      id: testingInfo?.id,
      STATUS: status,
    };

    try {
      const response = await auditService.updateWorkpaper(
        testingInfo.id,
        updatedData
      );
    } catch (error) {
      console.error("Error updating workpaper status:", error);
    }
  };

  const renderLoadingState = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
        backgroundColor: "whitesmoke",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <CircularProgress size={60} thickness={4} />
        <Typography
          variant="h6"
          sx={{
            mt: 2,
            color: "text.secondary",
            fontWeight: 500,
          }}
        >
          Loading Workpaper Details...
        </Typography>
      </Box>
    </Box>
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        await fetchApp();
        await fetchProjectbyID();
        await fetchAuditUsers();
        if (workpaperID) {
          await fetchDesignEvidence(workpaperID);
          await fetchInterimEvidence(workpaperID);
          await fetchRFEvidence(workpaperID);
          await fetchFinalEvidence(workpaperID);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [workpaperID]);

  const fetchApp = async () => {
    try {
      const app = await appService.fetchAppsById(app_id);
      if (app) {
        setApps(app);
        setSelectedApp(app);
        setAppID(app_id);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchProjectbyID = async () => {
    try {
      const projectRecord = await auditService.fetchProjectsById(id);
      if (projectRecord) {
        setSelectedProject(projectRecord);
        setCompanyID(projectRecord.COMPANY_ID);
      }

      if (controlref) {
         await fetchTesting(controlref);
      }
    } catch (fetchError) {
      console.error("Error fetching company:", fetchError);
      setSelectedProject([]);
    }
  };

  const fetchAuditUsers = async () => {
    try {
      const users = await roleService.fetchUsersByAudit(id);
      
      if (!users || !Array.isArray(users)) {
        throw new Error('Invalid response format from server');
      }

      // Format users for dropdown, handling potential undefined values
      const formattedUsers = users.map(user => ({
        id: user.id,
        email: user?.user?.email || user.email || '',
        fullName: user?.user ? 
          `${user.user.first_name || ''} ${user.user.last_name || ''}`.trim() :
          user.email || 'Unknown User',
        displayName: user?.user ? 
          `${user.user.first_name || ''} ${user.user.last_name || ''} (${user?.user?.email || user.email || ''})`.trim() :
          user.email || 'Unknown User'
      })).filter(user => user.fullName && user.fullName !== 'Unknown User');

      setAuditUsers(formattedUsers);
    } catch (error) {
      console.error('Error fetching audit users:', error);
      setSnackbarMessage('Error fetching users: ' + (error.message || 'Unknown error'));
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setAuditUsers([]);
    }
  };

  const fetchDesignEvidence = async (workpaperId) => {
    try {
      const evidence = await auditService.fetchDesignEvidence(workpaperId);
      if (evidence) {
        const processedFiles = evidence.map((file) => ({
          id: file.id,
          original_filename: file.original_filename,
          name: file.original_filename,
          file_name: file.file_name,
          file_size: file.file_size,
          file_type: file.file_type,
          url: file.file_name
            ? `${process.env.REACT_APP_API_URL}/media/${file.file_name}`
            : null,
        }));
        setUploadedFiles(processedFiles);
      }
    } catch (error) {
      console.error("Error fetching design evidence:", error);
    }
  };

  const fetchInterimEvidence = async (workpaperId) => {
    try {
      const evidence = await auditService.fetchInterimEvidence(workpaperId);
      if (evidence) {
        const processedFiles = evidence.map((file) => ({
          id: file.id,
          original_filename: file.original_filename,
          name: file.original_filename,
          file_name: file.file_name,
          file_size: file.file_size,
          file_type: file.file_type,
          url: file.file_name
            ? `${process.env.REACT_APP_API_URL}/media/${file.file_name}`
            : null,
        }));
        setInterimFiles(processedFiles);
      }
    } catch (error) {
      console.error("Error fetching interim evidence:", error);
    }
  };

  const fetchRFEvidence = async (workpaperId) => {
    try {
      const evidence = await auditService.fetchRFEvidence(workpaperId);
      if (evidence) {
        const processedFiles = evidence.map((file) => ({
          id: file.id,
          original_filename: file.original_filename,
          name: file.original_filename,
          file_name: file.file_name,
          file_size: file.file_size,
          file_type: file.file_type,
          url: file.file_name
            ? `${process.env.REACT_APP_API_URL}/media/${file.file_name}`
            : null,
        }));
        setRfFiles(processedFiles);
      }
    } catch (error) {
      console.error("Error fetching RF evidence:", error);
    }
  };

  const fetchFinalEvidence = async (workpaperId) => {
    try {
      const evidence = await auditService.fetchFinalEvidence(workpaperId);
      if (evidence) {
        const processedFiles = evidence.map((file) => ({
          id: file.id,
          original_filename: file.original_filename,
          name: file.original_filename,
          file_name: file.file_name,
          file_size: file.file_size,
          file_type: file.file_type,
          url: file.file_name
            ? `${process.env.REACT_APP_API_URL}/media/${file.file_name}`
            : null,
        }));
        setFinalFiles(processedFiles);
      }
    } catch (error) {
      console.error("Error fetching final evidence:", error);
    }
  };

    // Add helper function to get initials
    const getInitials = (name) => {
      if (!name) return '';
      // Handle email addresses
      if (name.includes('@')) {
        return name[0].toUpperCase();
      }
      // Get first letter of the first word, ensuring it exists
      const firstWord = name.split(' ')[0] || '';
      return firstWord[0] ? firstWord[0].toUpperCase() : '';
    };

  const fetchTesting = async (controlref) => {

    try {

      const testing = await auditService.fetchWorkpapersById(controlref);

      if (testing) {
        
        setWorkpaperStatus(testing.STATUS);

        try {
          let workpaperDetails = await auditService.fetchWorkpaperDetailsById(
            testing.id
          );

          if (workpaperDetails && workpaperDetails.length > 0) {


            setWorkpaperDetailsExisting(true);
            setWorkpaperDetails(workpaperDetails);
            setWorkpaperID(workpaperDetails[0].id);
            
            // Update testingInfo with workpaper details
            setTestingInfo({
              ...testing,
              ASSIGNED_TO: workpaperDetails[0].ASSIGNED_TO || testing.ASSIGNED_TO
            });
            
            // Design phase
            setDesignProcedure(workpaperDetails[0].DESIGN_PROCEDURES || "");
            setDesignResult(workpaperDetails[0].DESIGN_RESULT || "");
            setDesignConclusion(workpaperDetails[0].DESIGN_CONCLUSION || "");
            setDesignConclusionRationale(workpaperDetails[0].DESIGN_CONCLUSION_RATIONALE || "");
            
            // Interim phase
            setInterimProcedure(workpaperDetails[0].INTERIM_PROCEDURES || "");
            setInterimResult(workpaperDetails[0].INTERIM_RESULT || "");
            setInterimConclusion(workpaperDetails[0].INTERIM_CONCLUSION || "");
            setInterimConclusionRationale(workpaperDetails[0].INTERIM_CONCLUSION_RATIONALE || "");
            
            // Rollforward phase
            setRfProcedure(workpaperDetails[0].RF_PROCEDURES || "");
            setRfResult(workpaperDetails[0].RF_RESULT || "");
            setRfConclusion(workpaperDetails[0].RF_CONCLUSION || "");
            setRfConclusionRationale(workpaperDetails[0].RF_CONCLUSION_RATIONALE || "");
            
            // Final phase
            setFinalProcedure(workpaperDetails[0].FINAL_PROCEDURES || "");
            setFinalResult(workpaperDetails[0].FINAL_RESULT || "");
            setFinalConclusion(workpaperDetails[0].FINAL_CONCLUSION || "");
            setFinalConclusionRationale(workpaperDetails[0].FINAL_CONCLUSION_RATIONALE || "");

            // Deficiency details
            setDeficiencyType(workpaperDetails[0].DEFICIENCY_TYPE || "");
            setDeficiencyDescription(workpaperDetails[0].DEFICIENCY_DESCRIPTION || "");
            setDateIdentified(workpaperDetails[0].DATE_IDENTIFIED || "");
            setRootCause(workpaperDetails[0].ROOT_CAUSE || "");
            setManagementActionPlan(workpaperDetails[0].MANAGEMENT_ACTION_PLAN || "");
            setRemediationOwner(workpaperDetails[0].REMEDIATION_OWNER || "");
            setRemediationStatus(workpaperDetails[0].REMEDIATION_STATUS || "Unremediated");
            setDateClosed(workpaperDetails[0].DATE_REMEDIATED || "");  // Changed from DATE_CLOSED to DATE_REMEDIATED
            setMitigatingControls(workpaperDetails[0].MITIGATING_CONTROLS || "");

            // Add these lines to set the initial procedure types
            setDesignProcedureType(workpaperDetails[0].DESIGN_PROCEDURES_TYPE || "");
            setInterimProcedureType(workpaperDetails[0].INTERIM_PROCEDURES_TYPE || "");
            setRfProcedureType(workpaperDetails[0].RF_PROCEDURES_TYPE || "");
            setFinalProcedureType(workpaperDetails[0].FINAL_PROCEDURES_TYPE || "");

            // Add these lines to set the initial applicability states
            setInterimApplicable(workpaperDetails[0].INTERIM_APPLICABLE || "Yes");
            setRfApplicable(workpaperDetails[0].RF_APPLICABLE || "Yes");
            setFinalApplicable(workpaperDetails[0].FINAL_APPLICABLE || "Yes");

            // Add these lines to set the initial tester/reviewer assignments
            setDesignTester(workpaperDetails[0].DESIGN_TESTER || "");
            setDesignReviewer(workpaperDetails[0].DESIGN_REVIEWER || "");
            setInterimTester(workpaperDetails[0].INTERIM_TESTER || "");
            setInterimReviewer(workpaperDetails[0].INTERIM_REVIEWER || "");
            setRfTester(workpaperDetails[0].RF_TESTER || "");
            setRfReviewer(workpaperDetails[0].RF_REVIEWER || "");
            setFinalTester(workpaperDetails[0].FINAL_TESTER || "");
            setFinalReviewer(workpaperDetails[0].FINAL_REVIEWER || "");

            // Fetch design evidence for this workpaper
            await fetchDesignEvidence(workpaperDetails[0].id);
          } 
    
        } catch (error) {
          console.error("Error fetching workpaper details:", error);
        }
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }

  };

  const fetchProcedures = async () => {
    try {
      const procedureList = await auditService.fetchProcedures();

      if (procedureList) {
        const procedureName = procedureList.map((item) => ({
          value: item.CONTROL_TITLE,
          label: item.CONTROL_TITLE,
        }));

        setProcedureOptions(procedureName);
      }
    } catch (fetchError) {
      console.error("Error fetching procedures:", fetchError);
      setProcedureOptions([]);
    }
  };

  const fetchTestProcedure = async (phase, procedureName) => {
    let procedure;
    try {
      procedure = await auditService.fetchWorkpapersById(phase);
      // Handle the data here, e.g., set state
    } catch (error) {
      // Handle errors here
      console.error("Failed to fetch data:", error);
    }

    if (procedure) {
      setSelectedProcedures(procedure);
    } else {
      setSelectedProcedures([]);
    }
  };

  const handleOpenModal = (tab = "design", procedureType = null) => {
    if (tab === "generate") {
      // If procedureType is provided, use it directly
      if (procedureType) {
        setCurrentProcedureType(procedureType);
      } else {
        // Fallback to using modalTabValue for the design tab
        setCurrentProcedureType("design");
      }
      setShowGenerateConfirmation(true);
    } else {
      setModalTabValue(tab);
      setOpenModal(true);
    }
  };

  const handleCloseModal = (event, reason) => {
    if (reason == "backdropClick") {
      setOpenModal(true);
    } else {
      setOpenModal(false);
    }
  };

  useEffect(() => {
    const fetchControlOptions = async () => {
      try {
        // First fetch all procedures to get controls that have procedures set up
        const procedures = await auditService.fetchProcedures();
        console.log("Fetched procedures:", procedures); // Debug log

        if (procedures && procedures.length > 0) {
          // Get unique control IDs from procedures
          const controlIds = [
            ...new Set(
              procedures.map((proc) => {
                console.log("Processing procedure:", proc); // Debug log
                return proc.CONTROL_ID; // Remove .id since CONTROL_ID might be the ID itself
              })
            ),
          ];
          console.log("Unique control IDs:", controlIds); // Debug log

          // Fetch control details for these specific controls
          const controls = await auditService.fetchControls();
          console.log("All controls:", controls); // Debug log

          const filteredControls = controls.filter((control) =>
            controlIds.includes(control.id)
          );
          console.log("Filtered controls:", filteredControls); // Debug log

          const options = filteredControls.map((control) => ({
            value: control.id,
            label: `${control.CONTROL_ID} - ${control.CONTROL_TITLE}`,
          }));
          console.log("Control options:", options); // Debug log

          setControlOptions(options);
        }
      } catch (error) {
        console.error("Error fetching controls:", error);
      }
    };
    fetchControlOptions();
  }, []);

  const handleControlChange = async (selectedOption) => {
    console.log("Selected Control:", selectedOption);
    setSelectedControl(selectedOption);
    if (selectedOption?.value) {
      try {
        const procedures = await auditService.fetchProceduresById(
          selectedOption.value
        );
        console.log("Fetched Procedures:", procedures);

        if (procedures) {
          const updatedProcedures = {
            DESIGN_PROCEDURES: procedures.DESIGN_PROCEDURES || "",
            INTERIM_PROCEDURES: procedures.INTERIM_PROCEDURES || "",
            ROLLFORWARD_PROCEDURES: procedures.ROLLFORWARD_PROCEDURES || "",
            FINAL_PROCEDURES: procedures.FINAL_PROCEDURES || "",
          };
          setModalProceduresData(updatedProcedures);
        }
      } catch (error) {
        console.error("Error fetching procedures:", error);
      }
    }
  };

  const handleSignOffClick = () => {
    setSignOffDialogOpen(true);
  };

  const handleSignOffDialogClose = () => {
    setSignOffDialogOpen(false);
    setSignOffRole('');
    setSignOffPhase('');
  };

  const handleSignOffSubmit = async () => {
    try {
      const currentUserEmail = currentUser.email;
      const data = {
        AUDIT_FILE: testingInfo.id,
      };

      // Check if user is authorized to sign off
      const isAuthorized = signOffRole === 'Tester' 
        ? workpaperDetails?.[0]?.[`${signOffPhase}_TESTER`] === currentUserEmail || !workpaperDetails?.[0]?.[`${signOffPhase}_TESTER`]
        : workpaperDetails?.[0]?.[`${signOffPhase}_REVIEWER`] === currentUserEmail || !workpaperDetails?.[0]?.[`${signOffPhase}_REVIEWER`];

      if (!isAuthorized) {
        setSnackbarMessage('You are not authorized to sign off as ' + signOffRole + ' for this phase');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }

      // Update the appropriate fields based on phase and role
      if (signOffRole === 'Tester') {
        data[`${signOffPhase}_TESTER_SIGNOFF`] = new Date().toISOString();
      } else if (signOffRole === 'Reviewer') {
        data[`${signOffPhase}_REVIEWER_SIGNOFF`] = new Date().toISOString();
      }

      if (workpaperDetailsExisting) {
        await auditService.updateWorkpaperDetails(workpaperID, data);
        
        // Refresh workpaper details
        const updatedDetails = await auditService.fetchWorkpaperDetailsById(testingInfo.id);
        if (updatedDetails && updatedDetails.length > 0) {
          setWorkpaperDetails(updatedDetails);
        }
        
        setSnackbarMessage('Sign-off completed successfully');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error('Error during sign-off:', error);
      setSnackbarMessage('Error during sign-off');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
    handleSignOffDialogClose();
  };

  // Add this near other state declarations
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [procedureToConfirm, setProcedureToConfirm] = useState(null);

  const handleUseProcedure = () => {
    // Store the procedure data to be confirmed
    setProcedureToConfirm({
      type: modalTabValue,
      data: modalProceduresData[`${modalTabValue.toUpperCase()}_PROCEDURES`],
    });
    setConfirmDialogOpen(true);
  };

  const handleConfirmProcedure = () => {
    // Update the workpaper procedure based on the selected tab
    switch (procedureToConfirm.type) {
      case "design":
        setDesignProcedure(procedureToConfirm.data);
        handleWorkpaperSave(procedureToConfirm.data, "designProcedure");
        break;
      case "interim":
        setInterimProcedure(procedureToConfirm.data);
        handleWorkpaperSave(procedureToConfirm.data, "interimProcedure");
        break;
      case "rollforward":
        setRfProcedure(procedureToConfirm.data);
        handleWorkpaperSave(procedureToConfirm.data, "rfProcedure");
        break;
      case "final":
        setFinalProcedure(procedureToConfirm.data);
        handleWorkpaperSave(procedureToConfirm.data, "finalProcedure");
        break;
    }
    setConfirmDialogOpen(false);
    handleCloseModal();
  };

  // Add this near the AnalysisModal component
  const ConfirmProcedureDialog = () => (
    <Dialog
      open={confirmDialogOpen}
      onClose={() => setConfirmDialogOpen(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Confirm Procedure Update</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to update the {procedureToConfirm?.type}{" "}
          procedure? This will replace the existing procedure content.
        </DialogContentText>
        <Box sx={{ mt: 2, p: 2, bgcolor: "grey.100", borderRadius: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            New Procedure Content:
          </Typography>
          <div
            dangerouslySetInnerHTML={{ __html: procedureToConfirm?.data || "" }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setConfirmDialogOpen(false)}>Cancel</Button>
        <Button
          onClick={handleConfirmProcedure}
          variant="contained"
          color="primary"
        >
          Confirm Update
        </Button>
      </DialogActions>
    </Dialog>
  );

  const columns = [
    { field: "id", headerName: "#", width: 50 },
    {
      field: "TITLE",
      headerName: "Name",
      flex: 1,
      renderCell: (params) => (
        <span
          style={{
            cursor: "pointer",
            textDecoration: "underline",
          }}
          // onClick={() => handleTitleClick(params.row)}
        >
          {params.value}
        </span>
      ),
    },
    { field: "CURRENTLY_WITH", headerName: "Currently With", flex: 1 },
    { field: "STATUS", headerName: "Status", flex: 1 },
    { field: "TYPE", headerName: "Type", flex: 1 },
  ];

  const rows = Array.isArray(workpapers)
    ? workpapers.map((wp, index) => ({
        id: index + 1,
        TITLE: wp.TITLE || "-",
        CURRENTLY_WITH: wp.CURRENTLY_WITH || "-",
        STATUS: wp.STATUS || "-",
        TYPE: wp.TYPE || "-",
        ctrlID: wp.id,
      }))
    : [];

  const HeaderContainer = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.grey, // Light grey background
    padding: "10px 20px", // Adjust padding as needed
    borderRadius: "px 4px 0 0", // Rounded corners at the top
  }));

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleSwitchChange = async (event, phase) => {
    event.stopPropagation();
    let newValue;
    let field;
    let setter;

    switch (phase) {
      case "interim":
        newValue = interimApplicable === "Yes" ? "No" : "Yes";
        field = "INTERIM_APPLICABLE";
        setter = setInterimApplicable;
        break;
      case "rf":
        newValue = rfApplicable === "Yes" ? "No" : "Yes";
        field = "RF_APPLICABLE";
        setter = setRfApplicable;
        break;
      case "final":
        newValue = finalApplicable === "Yes" ? "No" : "Yes";
        field = "FINAL_APPLICABLE";
        setter = setFinalApplicable;
        break;
      default:
        return;
    }

    // Update local state
    setter(newValue);

    // Prepare data for API call
    const data = {
      AUDIT_FILE: testingInfo.id,
      [field]: newValue
    };

    try {
      if (workpaperDetailsExisting) {
        await auditService.updateWorkpaperDetails(workpaperID, data);
      } 
    } catch (error) {
      console.error(`Error updating ${phase} applicability:`, error);
      // Revert state on error
      setter(newValue === "Yes" ? "No" : "Yes");
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      [{ font: [] }],
      [{ size: ["small", "medium", "large", "huge"] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [{ color: [] }, { background: [] }],
      ["clean"],
      ["link"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "color",
    "background",
    "link",
  ];

  const phaseOptions = [
    { value: "Design", label: "Design" },
    { value: "Operating Effectiveness", label: "Operating Effectiveness" },
  ];

  const handlePhaseChange = (selectedType) => {
    const phase = {
      label: selectedType.value,
      value: selectedType.value,
    };
    setSelectedPhase(phase);

    setSelectedProcedureName([]);
    setSelectedProcedures([]);
  };

  const handleProcedureNameChange = (selectedType) => {
    const procedureName = {
      label: selectedType.value,
      value: selectedType.value,
    };

    // Ensure selectedPhase has a valid value
    if (!selectedPhase || !selectedPhase.value) {
      console.error("Selected phase is not defined");
      return;
    }

    // Filter procedures data based on phase and procedure name
    const selectedProcedure = proceduresData.filter(
      (proc) =>
        proc.CONTROL_TITLE === selectedType.value &&
        proc.CONTROL_TITLE === selectedPhase.value
    );

    setSelectedProcedureName(procedureName);

    // Check if any procedures match the criteria before setting them
    if (selectedProcedure.length > 0) {
      setSelectedProcedures(selectedProcedure[0].PROCEDURE_DETAILS || []);
    } else {
      setSelectedProcedures([]);
    }
  };

  const handleSectionClick = (section) => {
    // Remove the line that closes the review notes panel
    // setShowReviewNotes(false);

    // Wait for panel to close before scrolling
    setTimeout(() => {
      // Determine which tab to switch to based on the section
      let tabValue;
      if (section.startsWith("design")) {
        tabValue = "2"; // Design and Implementation tab
      } else if (
        section.startsWith("interim") ||
        section.startsWith("rf") ||
        section.startsWith("final")
      ) {
        tabValue = "3"; // Operating Effectiveness tab
      }

      // Find and click the appropriate tab
      const tabButton = document.querySelector(
        `[role="tab"][data-value="${tabValue}"]`
      );
      if (tabButton) {
        tabButton.click();
      }

      // Wait for tab content to render
      setTimeout(() => {
        // Find the editor container for the section
        const editorContainer = document.querySelector(
          `[data-section="${section}"]`
        );
        if (editorContainer) {
          editorContainer.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 300);
    }, 300);
  };

  const NoteComponent = ({
    note,
    isReply = false,
    onCategoryChange,
    onResolve,
    replyText,
    setReplyText,
    newNote,
    setNewNote,
    noteCategory,
    setReviewNotes,
  }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editedText, setEditedText] = useState(note.text);
    const [localReplyText, setLocalReplyText] = useState("");
    const [showReplyBox, setShowReplyBox] = useState(false);
    const [showReplies, setShowReplies] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const toggleFocus = (e) => {
      if (!isEditing) {
        e.stopPropagation();
        setIsFocused(!isFocused);
        // When focusing on a note, collapse other notes' replies
        setReviewNotes((prev) =>
          prev.map((n) => {
            if (n.id !== note.id) {
              return { ...n, isFocused: false };
            }
            return { ...n, isFocused: !isFocused };
          })
        );
      }
    };

    const handleReplyClick = (e) => {
      e.stopPropagation();
      setShowReplies(!showReplies);
      setShowReplyBox(!showReplyBox);
      if (!showReplies) {
        setIsFocused(true);
      }
    };

    const toggleExpand = (e) => {
      if (!isEditing) {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
      }
    };

    const handleEdit = (e) => {
      e.stopPropagation();
      setIsEditing(true);
      setEditedText(note.text);
      setIsFocused(true);
    };

    const handleSaveEdit = async (e) => {
      e.stopPropagation();
      try {
        const updatedNote = await reviewNotesService.updateNoteText(
          note.id,
          editedText
        );

        setReviewNotes((prev) => {
          if (note.parent) {
            // If this is a reply, update it in its parent's replies array
            return prev.map((mainNote) => ({
              ...mainNote,
              replies: (mainNote.replies || []).map((reply) =>
                reply.id === note.id ? { ...reply, text: editedText } : reply
              ),
            }));
          }
          // If this is a main note, update it directly
          return prev.map((n) =>
            n.id === note.id ? { ...n, text: editedText } : n
          );
        });

        setIsEditing(false);
      } catch (error) {
        console.error("Error updating note:", error);
      }
    };

    const handleCancelEdit = (e) => {
      e.stopPropagation();
      setEditedText(note.text);
      setIsEditing(false);
    };

    const handleDelete = async (e) => {
      e.stopPropagation();
      setShowDeleteConfirm(true);
    };

    const confirmDelete = async () => {
      try {
        await reviewNotesService.deleteReviewNote(note.id);

        setReviewNotes((prev) => {
          if (note.parent) {
            // If this is a reply, remove it from its parent's replies array
            return prev.map((mainNote) => ({
              ...mainNote,
              replies: (mainNote.replies || []).filter(
                (reply) => reply.id !== note.id
              ),
            }));
          }
          // If this is a main note, remove it from the main array
          return prev.filter((n) => n.id !== note.id);
        });
      } catch (error) {
        console.error("Error deleting note:", error);
      } finally {
        setShowDeleteConfirm(false);
      }
    };

    const handleReply = async (e) => {
      e.stopPropagation();
      if (!localReplyText.trim()) return;

      try {
        const noteData = {
          text: localReplyText,
          section: note.section,
          category: noteCategory,
          parent: note.id,
          workpaper_details: workpaperID,
          user: `${currentUser.first_name} ${currentUser.last_name}`,
        };

        const newReply = await reviewNotesService.createReviewNote(
          workpaperID,
          noteData
        );

        setReviewNotes((prev) =>
          prev.map((n) => {
            if (n.id === note.id) {
              return {
                ...n,
                replies: [...(n.replies || []), newReply],
              };
            }
            return n;
          })
        );

        setLocalReplyText("");
        setShowReplyBox(false);
      } catch (error) {
        console.error("Error adding reply:", error);
      }
    };

    const getCategoryColor = (category) => {
      switch (category) {
        case "urgent":
          return "#f44336";
        case "todo":
          return "#2196f3";
        default:
          return "#ff9800"; // Orange color
      }
    };

    // ... rest of your existing state declarations ...

    const getCategoryIcon = (category) => {
      switch (category) {
        case "urgent":
          return <ErrorOutlineIcon />;
        case "todo":
          return <AssignmentIcon />;
        default:
          return <StickyNote2Icon />;
      }
    };

    return (
      <Box
        sx={{
          mb: 2,
          p: 2,
          bgcolor: isReply ? "#ffffff" : "#f5f5f5",
          borderRadius: 1,
          borderLeft: isReply
            ? "2px solid #e0e0e0"
            : `4px solid ${
                note.resolved ? "#4caf50" : getCategoryColor(note.category)
              }`,
          ml: isReply ? 3 : 0,
          boxShadow: isReply ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
          position: "relative",
          cursor: isEditing ? "default" : "pointer",
          transition: "all 0.2s ease",
          "&:hover": {
            bgcolor: isReply ? "#f0fafa" : "#eeeeee",
          },
          ...(note.resolved && {
            bgcolor: isReply ? "#f0fff0" : "#f0fff0",
            "&:hover": {
              bgcolor: "#e8f5e8",
            },
          }),
        }}
        onClick={(e) => {
          if (!isEditing && note.section) {
            e.stopPropagation();
            handleSectionClick(note.section);
          } else {
            toggleFocus(e);
          }
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {/* Top row with category icon and action buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {!isReply && (
                <Box
                  component="span"
                  sx={{
                    color: note.resolved
                      ? "#4caf50"
                      : getCategoryColor(note.category),
                    fontSize: "1.2rem",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  {note.resolved ? (
                    <CheckCircleIcon />
                  ) : (
                    getCategoryIcon(note.category)
                  )}
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 700,
                      color: "text.primary",
                      lineHeight: 1.2,
                    }}
                  >
                    {note.user}
                  </Typography>
                </Box>
              )}
              {isReply && (
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 700,
                    color: "text.primary",
                    lineHeight: 1.2,
                  }}
                >
                  {note.user}
                </Typography>
              )}
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              {!isReply && (
                <>
                  <Tooltip
                    title={`${note.replies?.length || 0} ${
                      (note.replies?.length || 0) === 1 ? "reply" : "replies"
                    }`}
                  >
                    <Box sx={{ position: "relative" }}>
                      <IconButton
                        size="small"
                        onClick={handleReplyClick}
                        sx={{
                          color: showReplies ? "#1976d2" : "grey.500",
                          "&:hover": { color: "#1976d2" },
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                      {note.replies && note.replies.length > 0 && (
                        <Box
                          onClick={handleReplyClick}
                          sx={{
                            position: "absolute",
                            top: -8,
                            right: -8,
                            bgcolor: showReplies ? "#1976d2" : "#757575",
                            color: "white",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "0.75rem",
                            fontWeight: "bold",
                            cursor: "pointer",
                            "&:hover": {
                              bgcolor: "#1976d2",
                            },
                          }}
                        >
                          {note.replies.length}
                        </Box>
                      )}
                    </Box>
                  </Tooltip>
                  <Tooltip title="Change Category">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        onCategoryChange(note.id);
                      }}
                    >
                      <TagIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Mark as Resolved">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        onResolve(note.id);
                      }}
                      sx={{
                        color: note.resolved ? "#4caf50" : "grey.500",
                        "&:hover": { color: "#4caf50" },
                      }}
                    >
                      <AssignmentTurnedInRoundedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete Note">
                    <IconButton
                      size="small"
                      onClick={handleDelete}
                      sx={{
                        color: "grey.500",
                        "&:hover": { color: "grey.700" },
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </>
              )}
              {isReply &&
                (isEditing ? (
                  <>
                    <Tooltip title="Save">
                      <IconButton
                        size="small"
                        onClick={handleSaveEdit}
                        sx={{ color: "#4caf50" }}
                      >
                        <CheckCircleIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Cancel">
                      <IconButton
                        size="small"
                        onClick={handleCancelEdit}
                        sx={{ color: "#f44336" }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        onClick={handleEdit}
                        sx={{
                          color: "#2196f3",
                          "&:hover": { color: "#1976d2" },
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={handleDelete}
                        sx={{
                          color: "grey.500",
                          "&:hover": { color: "#grey.700" },
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </>
                ))}
            </Box>
          </Box>

          {/* Content area */}
          <Box sx={{ width: "100%" }}>
            {isEditing ? (
              <TextField
                fullWidth
                multiline
                size="small"
                value={editedText}
                onChange={(e) => setEditedText(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                sx={{ mb: 1 }}
                rows={3}
                autoFocus
              />
            ) : (
              <Box onClick={toggleExpand} sx={{ cursor: "pointer" }}>
                <Typography
                  variant="body2"
                  sx={{
                    display: isExpanded ? "block" : "-webkit-box",
                    WebkitLineClamp: isExpanded ? "unset" : 2,
                    WebkitBoxOrient: "vertical",
                    overflow: isExpanded ? "visible" : "hidden",
                    textOverflow: isExpanded ? "clip" : "ellipsis",
                    color: note.resolved ? "#4caf50" : "inherit",
                    position: "relative",
                  }}
                >
                  {note.text}
                  {!isExpanded && note.text.length > 150 && (
                    <Typography
                      component="span"
                      sx={{
                        color: "text.secondary",
                        fontSize: "0.8rem",
                        ml: 0.5,
                        cursor: "pointer",
                      }}
                    >
                      ...more
                    </Typography>
                  )}
                  {isExpanded && (
                    <Typography
                      component="span"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsExpanded(false);
                      }}
                      sx={{
                        color: "text.secondary",
                        fontSize: "0.8rem",
                        ml: 0.5,
                        cursor: "pointer",
                        display: "block",
                        mt: 1,
                      }}
                    >
                      Show less
                    </Typography>
                  )}
                </Typography>
              </Box>
            )}
          </Box>

          <Typography variant="caption" color="text.secondary">
            {new Date(note.timestamp).toLocaleString()}
          </Typography>

          {/* Replies section - show when showReplies is true */}
          {note.replies && note.replies.length > 0 && showReplies && (
            <Box sx={{ mt: 2 }}>
              {note.replies.map((reply) => (
                <NoteComponent
                  key={reply.id}
                  note={reply}
                  isReply={true}
                  onCategoryChange={onCategoryChange}
                  onResolve={onResolve}
                  replyText={replyText}
                  setReplyText={setReplyText}
                  newNote={newNote}
                  setNewNote={setNewNote}
                  noteCategory={noteCategory}
                  setReviewNotes={setReviewNotes}
                />
              ))}
            </Box>
          )}

          {/* Reply box */}
          {showReplyBox && !isReply && (
            <Box sx={{ mt: 2 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Write a reply..."
                value={localReplyText}
                onChange={(e) => setLocalReplyText(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                sx={{ mb: 1 }}
                multiline
                rows={2}
              />
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  size="small"
                  variant="contained"
                  onClick={handleReply}
                  disabled={!localReplyText.trim()}
                >
                  Reply
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowReplyBox(false);
                    setLocalReplyText("");
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          )}
        </Box>

        {/* Add Dialog for delete confirmation */}
        <Dialog
          open={showDeleteConfirm}
          onClose={() => setShowDeleteConfirm(false)}
          onClick={(e) => e.stopPropagation()}
        >
          <DialogTitle>{isReply ? "Delete Reply" : "Delete Note"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this {isReply ? "reply" : "note"}?
              This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setShowDeleteConfirm(false);
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                confirmDelete();
              }}
              color="error"
              variant="contained"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  };

  const addReviewNote = async (section, parentId = null) => {
    const text = parentId ? replyText : newNote;
    console.log(text);
    if (!text.trim()) return;

    const noteData = {
      text: text,
      section: section,
      category: noteCategory,
      parent: parentId,
      highlighted_text: highlightedText,
      workpaper_details: workpaperID,
      user: `${currentUser.first_name} ${currentUser.last_name}`,
    };

    console.log(noteData);

    try {
      const newNoteObj = await reviewNotesService.createReviewNote(
        workpaperID,
        noteData
      );

      if (parentId) {
        setReviewNotes((prev) =>
          prev.map((note) =>
            note.id === parentId
              ? { ...note, replies: [...(note.replies || []), newNoteObj] }
              : note
          )
        );
        setReplyText("");
      } else {
        setReviewNotes((prev) => [...prev, newNoteObj]);
        setNewNote("");
      }
    } catch (error) {
      console.error("Error adding review note:", error);
    }
  };

  const ReviewNotesPanel = ({ section }) => {
    const [panelNoteCategory, setPanelNoteCategory] = useState("normal");
    const [panelNewNote, setPanelNewNote] = useState("");
    const [panelReplyingTo, setPanelReplyingTo] = useState(null);
    const [panelReplyText, setPanelReplyText] = useState("");
    const [activeFilter, setActiveFilter] = useState("all");

    const handleAddNote = async (section, parentId = null) => {
      console.log("This is the workpaper id", workpaperID);
      const text = parentId ? panelReplyText : panelNewNote;
      if (!text.trim()) return;

      const noteData = {
        text: text,
        section: section,
        category: panelNoteCategory,
        parent: parentId,
        workpaper_details: workpaperID,
        user: `${currentUser.first_name} ${currentUser.last_name}`,
      };

      try {
        const newNoteObj = await reviewNotesService.createReviewNote(
          workpaperID,
          noteData
        );

        if (parentId) {
          setReviewNotes((prev) =>
            prev.map((note) =>
              note.id === parentId
                ? { ...note, replies: [...(note.replies || []), newNoteObj] }
                : note
            )
          );
          setPanelReplyText("");
          setPanelReplyingTo(null);
        } else {
          setReviewNotes((prev) => [...prev, newNoteObj]);
          setPanelNewNote("");
        }
      } catch (error) {
        console.error("Error adding review note:", error);
      }
    };

    // Filter notes based on activeFilter
    const filteredNotes = useMemo(() => {
      if (!Array.isArray(reviewNotes)) return [];

      return reviewNotes.filter((note) => {
        if (activeFilter === "all") return true;
        if (activeFilter === "resolved") return note.resolved;
        return !note.resolved && note.category === activeFilter;
      });
    }, [reviewNotes, activeFilter]);

    // Count unresolved notes by category
    const noteCounts = useMemo(() => {
      if (!Array.isArray(reviewNotes))
        return { urgent: 0, normal: 0, todo: 0, resolved: 0 };

      return reviewNotes.reduce(
        (acc, note) => {
          if (note.resolved) {
            acc.resolved++;
          } else {
            acc[note.category]++;
          }
          return acc;
        },
        { urgent: 0, normal: 0, todo: 0, resolved: 0 }
      );
    }, [reviewNotes]);

    return (
      <Paper
        sx={{
          position: "fixed",
          right: 0,
          top: 0,
          height: "100vh",
          width: "400px",
          zIndex: 1000,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            p: 2,
            borderBottom: "1px solid #e0e0e0",
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Review Notes</Typography>
            <IconButton onClick={() => setShowReviewNotes(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Box
              onClick={() =>
                setActiveFilter(activeFilter === "urgent" ? "all" : "urgent")
              }
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                cursor: "pointer",
                bgcolor: activeFilter === "urgent" ? "#ffebee" : "transparent",
                p: 0.5,
                borderRadius: 1,
                transition: "all 0.2s",
                "&:hover": { bgcolor: "#ffebee" },
              }}
            >
              <ErrorOutlineIcon sx={{ color: "#f44336", fontSize: "1.2rem" }} />
              <Typography variant="caption" sx={{ color: "#f44336" }}>
                {noteCounts.urgent}
              </Typography>
            </Box>
            <Box
              onClick={() =>
                setActiveFilter(activeFilter === "normal" ? "all" : "normal")
              }
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                cursor: "pointer",
                bgcolor: activeFilter === "normal" ? "#fff3e0" : "transparent",
                p: 0.5,
                borderRadius: 1,
                transition: "all 0.2s",
                "&:hover": { bgcolor: "#fff3e0" },
              }}
            >
              <StickyNote2Icon sx={{ color: "#ff9800", fontSize: "1.2rem" }} />
              <Typography variant="caption" sx={{ color: "#ff9800" }}>
                {noteCounts.normal}
              </Typography>
            </Box>
            <Box
              onClick={() =>
                setActiveFilter(activeFilter === "todo" ? "all" : "todo")
              }
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                cursor: "pointer",
                bgcolor: activeFilter === "todo" ? "#e3f2fd" : "transparent",
                p: 0.5,
                borderRadius: 1,
                transition: "all 0.2s",
                "&:hover": { bgcolor: "#e3f2fd" },
              }}
            >
              <AssignmentIcon sx={{ color: "#2196f3", fontSize: "1.2rem" }} />
              <Typography variant="caption" sx={{ color: "#2196f3" }}>
                {noteCounts.todo}
              </Typography>
            </Box>
            <Box
              onClick={() =>
                setActiveFilter(
                  activeFilter === "resolved" ? "all" : "resolved"
                )
              }
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                cursor: "pointer",
                bgcolor:
                  activeFilter === "resolved" ? "#e8f5e9" : "transparent",
                p: 0.5,
                borderRadius: 1,
                transition: "all 0.2s",
                "&:hover": { bgcolor: "#e8f5e9" },
              }}
            >
              <CheckCircleIcon sx={{ color: "#4caf50", fontSize: "1.2rem" }} />
              <Typography variant="caption" sx={{ color: "#4caf50" }}>
                {noteCounts.resolved}
              </Typography>
            </Box>
          </Box>
          {activeFilter !== "all" && (
            <Chip
              label={`Filtering by: ${
                activeFilter.charAt(0).toUpperCase() + activeFilter.slice(1)
              }`}
              onDelete={() => setActiveFilter("all")}
              size="small"
              sx={{ alignSelf: "flex-start" }}
            />
          )}
        </Box>
        <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
          {isLoadingNotes ? (
            <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
              <CircularProgress />
            </Box>
          ) : (
            filteredNotes
              .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
              .map((note) => (
                <NoteComponent
                  key={note.id}
                  note={note}
                  onCategoryChange={handleCategoryChange}
                  onResolve={handleResolveNote}
                  onDelete={handleDeleteNote}
                  replyText={panelReplyText}
                  setReplyText={setPanelReplyText}
                  newNote={panelNewNote}
                  setNewNote={setPanelNewNote}
                  noteCategory={panelNoteCategory}
                  setReviewNotes={setReviewNotes}
                />
              ))
          )}
        </Box>

        <Box sx={{ p: 2, borderTop: "1px solid #e0e0e0" }}>
          <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
            <Tooltip title="Urgent">
              <IconButton
                size="small"
                onClick={() => setPanelNoteCategory("urgent")}
                sx={{
                  color:
                    panelNoteCategory === "urgent" ? "#f44336" : "grey.500",
                  "&:hover": { color: "#f44336" },
                }}
              >
                <ErrorOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Normal">
              <IconButton
                size="small"
                onClick={() => setPanelNoteCategory("normal")}
                sx={{
                  color:
                    panelNoteCategory === "normal" ? "#ff9800" : "grey.500",
                  "&:hover": { color: "#ff9800" },
                }}
              >
                <StickyNote2Icon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="To Do">
              <IconButton
                size="small"
                onClick={() => setPanelNoteCategory("todo")}
                sx={{
                  color: panelNoteCategory === "todo" ? "#2196f3" : "grey.500",
                  "&:hover": { color: "#2196f3" },
                }}
              >
                <AssignmentIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>

          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder="Write your note..."
            value={panelNewNote}
            onChange={(e) => setPanelNewNote(e.target.value)}
            sx={{ mb: 1 }}
          />
          <Button
            fullWidth
            variant="contained"
            onClick={() => handleAddNote(section)}
            disabled={!panelNewNote.trim()}
            startIcon={<ChatBubbleOutlineIcon />}
          >
            Add Note
          </Button>
        </Box>
      </Paper>
    );
  };

  const handleAnalyzeResult = async () => {
    try {
      setIsAnalyzing(true);
      const response = await auditService.AnalyzeResult(
        designProcedure,
        designResult
      );
      setAnalysisResult(response.analysis); // Remove .data since it's already unwrapped
      setShowAnalysisModal(true);
    } catch (error) {
      console.error("Error analyzing design result:", error);
    } finally {
      setIsAnalyzing(false);
    }
  };

  const AnalysisModal = () => (
    <Dialog
      open={showAnalysisModal}
      onClose={() => setShowAnalysisModal(false)}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle
        sx={{
          borderBottom: "1px solid #e0e0e0",
          backgroundColor: "#f8f9fa",
          py: 2,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <TipsAndUpdatesIcon color="primary" />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#1a237e",
              }}
            >
              Design Result Analysis
            </Typography>
          </Stack>

          
          <IconButton
            onClick={() => setShowAnalysisModal(false)}
            sx={{
              "&:hover": {
                backgroundColor: "rgba(25, 118, 210, 0.08)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box
          sx={{
            mt: 2,
            "& h3": {
              color: "#1a237e",
              fontWeight: 600,
              fontSize: "1.1rem",
              mb: 1.5,
              mt: 2,
              "&:first-child": {
                mt: 0,
              },
            },
            "& ul": {
              pl: 2,
              "& li": {
                mb: 1,
                lineHeight: 1.6,
                color: "#424242",
              },
            },
            "& p": {
              color: "#424242",
              lineHeight: 1.6,
              mb: 1.5,
            },
            "& strong": {
              color: "#1a237e",
              fontWeight: 600,
            },
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: analysisResult }} />
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          borderTop: "1px solid #e0e0e0",
          px: 3,
          py: 2,
        }}
      >
        <Button
          onClick={() => setShowAnalysisModal(false)}
          variant="outlined"
          color="primary"
          sx={{
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.08)",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  const EditorWithReviewNotes = React.memo(({ value, onChange, section }) => {
    // Local state to manage the editor's content
    const [localValue, setLocalValue] = useState(value);
    const [hasChanges, setHasChanges] = useState(false);
    const [isEditorLoading, setIsEditorLoading] = useState(true);
    const [wasSavedByBlur, setWasSavedByBlur] = useState(false);

    // Function to save data
    const saveData = async (newValue, field) => {
      onChange(newValue);
      let data = {
        AUDIT_FILE: testingInfo.id,
      };

      switch (field) {
        case "designProcedure":
          setDesignProcedure(newValue);
          data.DESIGN_PROCEDURES = newValue;
          break;
        case "designResult":
          setDesignResult(newValue);
          data.DESIGN_RESULT = newValue;
          break;
        case "designConclusion":
          setDesignConclusion(newValue);
          data.DESIGN_CONCLUSION = newValue;
          break;
        case "designConclusionRationale":
          setDesignConclusionRationale(newValue);
          data.DESIGN_CONCLUSION_RATIONALE = newValue;
          break;
        case "interimProcedure":
          setInterimProcedure(newValue);
          data.INTERIM_PROCEDURES = newValue;
          break;
        case "interimResult":
          setInterimResult(newValue);
          data.INTERIM_RESULT = newValue;
          break;
        case "interimConclusion":
          setInterimConclusion(newValue);
          data.INTERIM_CONCLUSION = newValue;
          break;
        case "interimConclusionRationale":
          setInterimConclusionRationale(newValue);
          data.INTERIM_CONCLUSION_RATIONALE = newValue;
          break;
        case "rfProcedure":
          setRfProcedure(newValue);
          data.RF_PROCEDURES = newValue;
          break;
        case "rfResult":
          setRfResult(newValue);
          data.RF_RESULT = newValue;
          break;
        case "rfConclusion":
          setRfConclusion(newValue);
          data.RF_CONCLUSION = newValue;
          break;
        case "rfConclusionRationale":
          setRfConclusionRationale(newValue);
          data.RF_CONCLUSION_RATIONALE = newValue;
          break;
        case "finalProcedure":
          setFinalProcedure(newValue);
          data.FINAL_PROCEDURES = newValue;
          break;
        case "finalResult":
          setFinalResult(newValue);
          data.FINAL_RESULT = newValue;
          break;
        case "finalConclusion":
          setFinalConclusion(newValue);
          data.FINAL_CONCLUSION = newValue;
          break;
        case "finalConclusionRationale":
          setFinalConclusionRationale(newValue);
          data.FINAL_CONCLUSION_RATIONALE = newValue;
          break;
        case "rollforwardPopulation":
          data.ROLLFORWARD_POPULATION = newValue;
          break;
        case "rollforwardSamples":
          data.ROLLFORWARD_SAMPLES = newValue;
          break;
        case "finalPopulation":
          data.FINAL_POPULATION = newValue;
          break;
        case "finalSamples":
          data.FINAL_SAMPLES = newValue;
          break;
        default:
          onChange(newValue);
          return;
      }

      try {
        if (workpaperDetailsExisting) {
          await auditService.updateWorkpaperDetails(workpaperID, data);
        } 
        setHasChanges(false);
        setWasSavedByBlur(false);
      } catch (error) {
        console.error("Error saving workpaper details:", error);
        console.error("Failed to save changes");
      }
    };

    // Debounced function to update parent
    const debouncedOnChange = React.useCallback(
      debounce(async (newValue, field) => {
        if (!wasSavedByBlur) {
          // Only save if not already saved by blur
          await saveData(newValue, field);
        }
      }, 600000),
      [onChange, wasSavedByBlur]
    );

    // Update local state when prop value changes
    React.useEffect(() => {
      setLocalValue(value);
    }, [value]);

    // Handle local changes
    const handleChange = React.useCallback(
      (newValue) => {
        setLocalValue(newValue);
        setHasChanges(true);
        debouncedOnChange(newValue, section);
      },
      [debouncedOnChange, section]
    );

    // Handle blur event
    const handleBlur = React.useCallback(
      (newValue) => {
        if (hasChanges) {
          setWasSavedByBlur(true); // Set flag before saving
          saveData(newValue, section);
        }
      },
      [section, hasChanges]
    );

    // Handle editor initialization
    const handleInit = React.useCallback(() => {
      setIsEditorLoading(false);
    }, []);

    return (
      <Box
        sx={{
          position: "relative",
          height: "100%",
          "& .tox-tinymce": {
            minHeight: "300px",
            maxHeight: "400px",
          },
        }}
        data-section={section}
      >
        {isEditorLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 1000,
            }}
          >
            <CircularProgress size={40} />
          </Box>
        )}
        <Editor
          apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
          value={localValue}
          onEditorChange={handleChange}
          onBlur={() => handleBlur(localValue)}
          onInit={handleInit}
          init={{
            height: 300,
            menubar: false,
            statusbar: false,
            branding: false,
            plugins: [
              "advlist",
              "autolink",
              "lists",
              "link",
              "image",
              "charmap",
              "preview",
              "anchor",
              "searchreplace",
              "visualblocks",
              "code",
              "fullscreen",
              "insertdatetime",
              "media",
              "table",
              "code",
              "help",
              "textcolor",
            ],
            toolbar:
              "undo redo | blocks | " +
              "bold italic backcolor forecolor | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat | help",
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
            setup: (editor) => {
              editor.on("init", () => {
                setIsEditorLoading(false);
              });
            },
            loading: " ", // This removes the default loading text
          }}
        />
      </Box>
    );
  });

  const tabs = [
    {
      value: "1",
      label: <div>Overview</div>,
      content: (
        <div>
            <Paper sx={{ padding: "20px" }}>
            <HeaderContainer>
              <Typography variant="h6" component="div">
                Control Information
              </Typography>
            </HeaderContainer>
            <Divider></Divider>
            <NormalTextField
              name="CONTROL_ID"
              label="Control ID"
              value={
                testingInfo?.CONTROL_DETAILS?.CONTROL_ID
                  ? testingInfo.CONTROL_DETAILS.CONTROL_ID
                  : ""
              }
            />
            <NormalTextField
              name="CONTROL_TITLE"
              label="Control Title"
              value={
                testingInfo?.CONTROL_DETAILS?.CONTROL_TITLE
                  ? testingInfo.CONTROL_DETAILS.CONTROL_TITLE
                  : ""
              }
            />
            <NormalTextField
              name="CONTROL_DESCRIPTION"
              label="Control Description"
              isMultiLine={true}
              rows="5"
              value={
                testingInfo?.CONTROL_DETAILS?.CONTROL_DESCRIPTION
                  ? testingInfo.CONTROL_DETAILS.CONTROL_DESCRIPTION
                  : ""
              }
            />
            <NormalTextField
              name="CONTROL_TYPE"
              label="Control Type"
              value={
                testingInfo?.CONTROL_DETAILS?.CONTROL_TYPE
                  ? testingInfo.CONTROL_DETAILS.CONTROL_TYPE
                  : ""
              }
            />

            <NormalTextField
              name="CONTROL_DOMAIN"
              label="Control Domain"
              value={
                testingInfo?.CONTROL_DETAILS?.CONTROL_DOMAIN
                  ? testingInfo.CONTROL_DETAILS.CONTROL_DOMAIN
                  : ""
              }
            />

            <NormalTextField
              name="CONTROL_CATEGORY"
              label="Control Category"
              value={
                testingInfo?.CONTROL_DETAILS?.CONTROL_CATEGORY
                  ? testingInfo.CONTROL_DETAILS.CONTROL_CATEGORY
                  : ""
              }
            />
          </Paper>

          {/* Testing Team Assignment Section */}
          <Paper 
            elevation={0}
            sx={{ 
              padding: "24px", 
              marginTop: "20px",
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
            }}
          >
            <Stack direction="row" spacing={1} sx={{ width: "100%", mb: 3 }} alignItems="center">
              <Typography 
                variant="subtitle1" 
                sx={{ 
                  fontWeight: 600,
                  color: 'text.primary',
                  flex: 1
                }}
              >
                Testing Team Assignment
              </Typography>
            </Stack>

            <Grid container spacing={3}>
              {[
                { 
                  phase: "Design Phase", 
                  tester: designTester,
                  reviewer: designReviewer,
                  testerField: 'designTester',
                  reviewerField: 'designReviewer'
                },
                { 
                  phase: "Interim Phase", 
                  tester: interimTester,
                  reviewer: interimReviewer,
                  testerField: 'interimTester',
                  reviewerField: 'interimReviewer'
                },
                { 
                  phase: "Rollforward Phase", 
                  tester: rfTester,
                  reviewer: rfReviewer,
                  testerField: 'rfTester',
                  reviewerField: 'rfReviewer'
                },
                { 
                  phase: "Final Phase", 
                  tester: finalTester,
                  reviewer: finalReviewer,
                  testerField: 'finalTester',
                  reviewerField: 'finalReviewer'
                }
              ].map((phase) => (
                <Grid item xs={12} key={phase.phase}>
                  <Box
                    sx={{
                      p: 2.5,
                      border: '1px solid',
                      borderColor: 'divider',
                      borderRadius: 2,
                      bgcolor: 'background.paper',
                      transition: 'all 0.2s ease-in-out',
                      '&:hover': {
                        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.02),
                        borderColor: 'primary.main',
                      }
                    }}
                  >
                    <Stack spacing={2}>
                      <Typography 
                        variant="subtitle2" 
                        sx={{ 
                          fontWeight: 600,
                          color: 'text.primary',
                          mb: 1
                        }}
                      >
                        {phase.phase}
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth size="small">
                            <InputLabel>Tester</InputLabel>
                            <Select
                              value={phase.tester}
                              onChange={(e) => handleAssignmentChange(phase.testerField, e.target.value)}
                              label="Tester"
                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {auditUsers.map((user) => (
                                <MenuItem key={user.id} value={user.email}>
                                  <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%' }}>
                                    <Avatar 
                                      sx={{ 
                                        width: 24, 
                                        height: 24, 
                                        fontSize: '0.75rem',
                                        bgcolor: 'primary.main'
                                      }}
                                    >
                                      {getInitials(user.fullName)}
                                    </Avatar>
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                      <Typography variant="body2" noWrap>{user.fullName}</Typography>
                                      <Typography variant="caption" color="text.secondary" noWrap>
                                        {user.email}
                                      </Typography>
                                    </Box>
                                  </Stack>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth size="small">
                            <InputLabel>Reviewer</InputLabel>
                            <Select
                              value={phase.reviewer}
                              onChange={(e) => handleAssignmentChange(phase.reviewerField, e.target.value)}
                              label="Reviewer"
                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {auditUsers.map((user) => (
                                <MenuItem key={user.id} value={user.email}>
                                  <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '100%' }}>
                                    <Avatar 
                                      sx={{ 
                                        width: 24, 
                                        height: 24, 
                                        fontSize: '0.75rem',
                                        bgcolor: 'secondary.main'
                                      }}
                                    >
                                      {getInitials(user.fullName)}
                                    </Avatar>
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                      <Typography variant="body2" noWrap>{user.fullName}</Typography>
                                      <Typography variant="caption" color="text.secondary" noWrap>
                                        {user.email}
                                      </Typography>
                                    </Box>
                                  </Stack>
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Stack>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Paper>

         
        </div>
      ),
    },
    {
      value: "2",
      label: <div>Design and Implementation</div>,
      content: (
        <div>
          <Paper sx={{ padding: "20px" }}>
            <Stack direction="row" spacing={1} sx={{ width: "100%", mb: 2 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 1, color: "text.secondary", fontWeight: 500 }}
                >
                  Test Type
                </Typography>
              </Box>
            </Stack>
            <TestTypeSelector
              value={designProcedureType}
              onChange={(newValue) => {
                setDesignProcedureType(newValue);
                handleWorkpaperSave(newValue, "designProcedureType");
              }}
            />
          </Paper>

          <Paper sx={{ padding: "20px", height: "450px", marginTop: "20px" }}>
            <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
              <Box sx={{ flexGrow: 1 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="subtitle1">Design Procedures</Typography>
                </Stack>
              </Box>

              <Tooltip title="Procedure Library">
                <IconButton onClick={() => handleOpenModal("design")}>
                  <LibraryBooksIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Generate Test Procedure">
                <IconButton
                  onClick={() => handleOpenModal("generate", "design")}
                  disabled={isGenerating}
                >
                  {isGenerating ? (
                    <CircularProgress size={20} />
                  ) : (
                    <AutoAwesomeIcon />
                  )}
                </IconButton>
              </Tooltip>

              <Tooltip title="Add Review Notes">
                <IconButton
                  onClick={() => {
                    setActiveSection("designProcedure");
                    setShowReviewNotes(true);
                  }}
                >
                  <ChatBubbleOutlineIcon />
                </IconButton>
              </Tooltip>
            </Stack>

            <EditorWithReviewNotes
              value={designProcedure}
              onChange={setDesignProcedure}
              section="designProcedure"
            />
          </Paper>

          <Paper sx={{ padding: "20px", height: "450px", marginTop: "20px" }}>
            <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
              <Box sx={{ flexGrow: 1 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="subtitle1">Design Result</Typography>
                </Stack>
              </Box>
              <Tooltip title="Document with AI">
                <IconButton onClick={handleOpenAIDialog}>
                  <AutoAwesomeIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Review Result">
                <IconButton
                  onClick={handleAnalyzeResult}
                  disabled={isAnalyzing}
                >
                  {isAnalyzing ? (
                    <CircularProgress size={24} />
                  ) : (
                    <TipsAndUpdatesIcon />
                  )}
                </IconButton>
              </Tooltip>

              <Tooltip title="Add Review Notes">
                <IconButton
                  onClick={() => {
                    setActiveSection("designResult");
                    setShowReviewNotes(true);
                  }}
                >
                  <ChatBubbleOutlineIcon />
                </IconButton>
              </Tooltip>
            </Stack>

            <EditorWithReviewNotes
              value={designResult}
              onChange={setDesignResult}
              section="designResult"
            />
          </Paper>

          <Paper sx={{ padding: "20px", height: "450px", marginTop: "20px" }}>
            <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
              <Box sx={{ flexGrow: 1 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="subtitle1">
                    Design and Implementation Evidence
                  </Typography>
                </Stack>
              </Box>
              <input
                type="file"
                ref={fileInputRef}
                hidden
                multiple
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.csv,.txt"
                onChange={handleFileSelect}
                style={{ display: "none" }}
              />

              <Tooltip title="Add Review Notes">
                <IconButton
                  onClick={() => {
                    setActiveSection("designEvidence");
                    setShowReviewNotes(true);
                  }}
                >
                  <ChatBubbleOutlineIcon />
                </IconButton>
              </Tooltip>
            </Stack>
            <Box
              component="div"
              onDragOver={handleDragOver}
              onDragEnter={handleDragEnter}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
              sx={{
                mt: 2,
                border: "2px dashed #bdbdbd",
                borderRadius: "8px",
                p: 3,
                backgroundColor: dragActive ? "#f5f5f5" : "#fafafa",
                borderColor: dragActive ? "#2196f3" : "#bdbdbd",
                textAlign: "center",
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": {
                  borderColor: "#2196f3",
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <CloudCircleIcon sx={{ fontSize: 48, color: "#bdbdbd", mb: 1 }} />
              <Typography variant="h6" color="textSecondary" gutterBottom>
                Drag & Drop Files Here
              </Typography>
              <Typography variant="body2" color="textSecondary">
                or click to select files
              </Typography>
            </Box>

            {/* File List */}
            {uploadedFiles.length > 0 && (
              <Box sx={{ mt: 2, maxHeight: "150px", overflow: "auto" }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Uploaded Files ({uploadedFiles.length})
                </Typography>
                <Paper
                  variant="outlined"
                  sx={{ maxHeight: "120px", overflow: "auto" }}
                >
                  {uploadedFiles.map((file, index) => (
                    <Box
                      key={file.id || index}
                      onClick={() => handleFileView(file)}
                      sx={{
                        p: 1,
                        display: "flex",
                        alignItems: "center",
                        borderBottom:
                          index < uploadedFiles.length - 1
                            ? "1px solid #eee"
                            : "none",
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#f5f5f5",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexGrow: 1,
                        }}
                      >
                        <Box sx={{ mr: 1 }}>
                          {getFileIcon(file.original_filename)}
                        </Box>
                        <Typography variant="body2">
                          {file.original_filename}
                        </Typography>
                      </Box>
                      <Tooltip title="Delete">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveFile(file.id);
                          }}
                          sx={{ color: "#757575" }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  ))}
                </Paper>
              </Box>
            )}
          </Paper>

          <Paper
            sx={{ padding: "20px", marginTop: "20px", marginBottom: "20px" }}
          >
            <Stack direction="row" spacing={1} sx={{ width: "100%", mb: 2 }}>
              <Box sx={{ flexGrow: 1 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="subtitle1">Conclusion</Typography>
                </Stack>
              </Box>
              <Tooltip title="Add Review Notes">
                <IconButton
                  onClick={() => {
                    setActiveSection("designConclusion");
                    setShowReviewNotes(true);
                  }}
                >
                  <ChatBubbleOutlineIcon />
                </IconButton>
              </Tooltip>
            </Stack>

            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 1 }}>
                Design Conclusion Status
              </Typography>
              <RadioGroup
                row
                value={designConclusion}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setDesignConclusion(newValue);
                  handleWorkpaperSave(newValue, "designConclusion");
                }}
              >
                <FormControlLabel
                  value="Effective"
                  control={<Radio />}
                  label="Effective"
                />
                <FormControlLabel
                  value="Not Effective"
                  control={<Radio />}
                  label="Not Effective"
                />
                <FormControlLabel
                  value="Inconclusive"
                  control={<Radio />}
                  label="Inconclusive"
                />
              </RadioGroup>
            </Box>
          </Paper>
        </div>
      ),
    },
    {
      value: "3",
      label: <div>Operating Effectiveness</div>,
      content: (
        <div>
          <Accordion
            expanded={true}
            sx={{
              mb: 2,
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h6">
                      <PagesIcon sx={{ marginRight: "5px", color: "grey" }} />
                      Interim
                    </Typography>
                  </Stack>
                </Box>
                <Switch
                  checked={interimApplicable === "Yes"}
                  onChange={(e) => handleSwitchChange(e, "interim")}
                  sx={{ marginLeft: "auto" }}
                />
              </Stack>
            </AccordionSummary>

            <AccordionDetails>
              <Paper sx={{ padding: "20px" }}>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ width: "100%", mb: 2 }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: 1, color: "text.secondary", fontWeight: 500 }}
                    >
                      Test Type
                    </Typography>
                  </Box>
                </Stack>
                <TestTypeSelector
                  value={interimProcedureType}
                  onChange={(newValue) => {
                    setInterimProcedureType(newValue);
                    handleWorkpaperSave(newValue, "interimProcedureType");
                  }}
                />
              </Paper>

              <Paper sx={{ padding: "20px", marginTop: "20px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2, color: "text.secondary" }}
                >
                  Population and Samples
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Population Size"
                      value={workpaperDetails?.[0]?.INTERIM_POPULATION || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setWorkpaperDetails(prev => [{
                          ...prev[0],
                          INTERIM_POPULATION: newValue
                        }]);
                        handleWorkpaperSave(newValue, "interimPopulation");
                      }}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Sample Size"
                      value={workpaperDetails?.[0]?.INTERIM_SAMPLES || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setWorkpaperDetails(prev => [{
                          ...prev[0],
                          INTERIM_SAMPLES: newValue
                        }]);
                        handleWorkpaperSave(newValue, "interimSamples");
                      }}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper
                sx={{ padding: "20px", height: "450px", marginTop: "20px" }}
              >
                <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="subtitle1">
                        Interim Procedures
                      </Typography>
                    </Stack>
                  </Box>
                  <Tooltip title="Procedure Library">
                    <IconButton onClick={() => handleOpenModal("interim")}>
                      <LibraryBooksIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Generate Test Procedure">
                    <IconButton
                      onClick={() => handleOpenModal("generate", "interim")}
                      disabled={isGenerating}
                    >
                      {isGenerating ? (
                        <CircularProgress size={20} />
                      ) : (
                        <AutoAwesomeIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("interimProcedure");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <EditorWithReviewNotes
                  value={interimProcedure}
                  onChange={setInterimProcedure}
                  section="interimProcedure"
                />
              </Paper>

              <Paper
                sx={{ padding: "20px", height: "450px", marginTop: "20px" }}
              >
                <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1">Interim Result</Typography>
                  </Box>
                  <Tooltip title="Document with AI">
                    <IconButton>
                      <AutoAwesomeIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Analyze Result">
                    <IconButton>
                      <TipsAndUpdatesIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("interimResult");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <EditorWithReviewNotes
                  value={interimResult}
                  onChange={setInterimResult}
                  section="interimResult"
                />
              </Paper>

              <Paper
                sx={{ padding: "20px", height: "450px", marginTop: "20px" }}
              >
                <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1">
                      Interim Evidence
                    </Typography>
                  </Box>
                  <input
                    type="file"
                    ref={interimFileInputRef}
                    hidden
                    multiple
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.csv,.txt"
                    onChange={handleInterimFileSelect}
                    style={{ display: "none" }}
                  />

                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("interimEvidence");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <Box
                  component="div"
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDrop={handleInterimDrop}
                  onClick={() => interimFileInputRef.current.click()}
                  sx={{
                    mt: 2,
                    border: "2px dashed #bdbdbd",
                    borderRadius: "8px",
                    p: 3,
                    backgroundColor: interimDragActive ? "#f5f5f5" : "#fafafa",
                    borderColor: interimDragActive ? "#2196f3" : "#bdbdbd",
                    textAlign: "center",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      borderColor: "#2196f3",
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  <CloudCircleIcon
                    sx={{ fontSize: 48, color: "#bdbdbd", mb: 1 }}
                  />
                  <Typography variant="h6" color="textSecondary" gutterBottom>
                    Drag & Drop Files Here
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    or click to select files
                  </Typography>
                </Box>

                {/* File List */}
                {interimFiles.length > 0 && (
                  <Box sx={{ mt: 2, maxHeight: "150px", overflow: "auto" }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      Uploaded Files ({interimFiles.length})
                    </Typography>
                    <Paper
                      variant="outlined"
                      sx={{ maxHeight: "120px", overflow: "auto" }}
                    >
                      {interimFiles.map((file, index) => (
                        <Box
                          key={file.id || index}
                          onClick={() => handleFileView(file)}
                          sx={{
                            p: 1,
                            display: "flex",
                            alignItems: "center",
                            borderBottom:
                              index < interimFiles.length - 1
                                ? "1px solid #eee"
                                : "none",
                            cursor: "pointer",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              flexGrow: 1,
                            }}
                          >
                            <Box sx={{ mr: 1 }}>
                              {getFileIcon(file.original_filename)}
                            </Box>
                            <Typography variant="body2">
                              {file.original_filename}
                            </Typography>
                          </Box>
                          <Tooltip title="Delete">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveInterimFile(file.id);
                              }}
                              sx={{ color: "#757575" }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ))}
                    </Paper>
                  </Box>
                )}
              </Paper>

              <Paper
                sx={{
                  padding: "20px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ width: "100%", mb: 2 }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1">Conclusion</Typography>
                  </Box>
                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("interimConclusion");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>

                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Interim Conclusion Status
                  </Typography>
                  <RadioGroup
                    row
                    value={interimConclusion}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setInterimConclusion(newValue);
                      handleWorkpaperSave(newValue, "interimConclusion");
                    }}
                  >
                    <FormControlLabel
                      value="Effective"
                      control={<Radio />}
                      label="Effective"
                    />
                    <FormControlLabel
                      value="Not Effective"
                      control={<Radio />}
                      label="Not Effective"
                    />
                    <FormControlLabel
                      value="Inconclusive"
                      control={<Radio />}
                      label="Inconclusive"
                    />
                  </RadioGroup>
                </Box>
              </Paper>
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={{
              mb: 2,
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h6">
                      <PagesIcon sx={{ marginRight: "5px", color: "grey" }} />
                      Rollforward
                    </Typography>
                  </Stack>
                </Box>
                <Switch
                  checked={rfApplicable === "Yes"}
                  onChange={(e) => handleSwitchChange(e, "rf")}
                  sx={{ marginLeft: "auto" }}
                />
              </Stack>
            </AccordionSummary>

            <AccordionDetails>
              <Paper sx={{ padding: "20px" }}>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ width: "100%", mb: 2 }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: 1, color: "text.secondary", fontWeight: 500 }}
                    >
                      Test Type
                    </Typography>
                  </Box>
                </Stack>
                <TestTypeSelector
                  value={rfProcedureType}
                  onChange={(newValue) => {
                    setRfProcedureType(newValue);
                    handleWorkpaperSave(newValue, "rfProcedureType");
                  }}
                />
              </Paper>

              <Paper sx={{ padding: "20px", marginTop: "20px" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2, color: "text.secondary" }}
                >
                  Population and Samples
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Population Size"
                      value={workpaperDetails?.[0]?.RF_POPULATION || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setWorkpaperDetails(prev => [{
                          ...prev[0],
                          RF_POPULATION: newValue
                        }]);
                        handleWorkpaperSave(newValue, "rfPopulation");
                      }}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Sample Size"
                      value={workpaperDetails?.[0]?.RF_SAMPLES || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setWorkpaperDetails(prev => [{
                          ...prev[0],
                          RF_SAMPLES: newValue
                        }]);
                        handleWorkpaperSave(newValue, "rfSamples");
                      }}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper
                sx={{ padding: "20px", height: "450px", marginTop: "20px" }}
              >
                <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="subtitle1">
                        Rollforward Procedures
                      </Typography>
                    </Stack>
                  </Box>
                  <Tooltip title="Procedure Library">
                    <IconButton onClick={() => handleOpenModal("rollforward")}>
                      <LibraryBooksIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Generate Test Procedure">
                    <IconButton
                      onClick={() => handleOpenModal("generate", "rollforward")}
                      disabled={isGenerating}
                    >
                      {isGenerating ? (
                        <CircularProgress size={20} />
                      ) : (
                        <AutoAwesomeIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("rfProcedure");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <EditorWithReviewNotes
                  value={rfProcedure}
                  onChange={setRfProcedure}
                  section="rfProcedure"
                />
              </Paper>

              <Paper
                sx={{ padding: "20px", height: "450px", marginTop: "20px" }}
              >
                <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1">
                      Rollforward Result
                    </Typography>
                  </Box>
                  <Tooltip title="Analyze Result">
                    <IconButton>
                      <TipsAndUpdatesIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("rfResult");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <EditorWithReviewNotes
                  value={rfResult}
                  onChange={setRfResult}
                  section="rfResult"
                />
              </Paper>

              <Paper
                sx={{ padding: "20px", height: "450px", marginTop: "20px" }}
              >
                <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1">
                      Rollforward Evidence
                    </Typography>
                  </Box>
                  <input
                    type="file"
                    ref={rfFileInputRef}
                    hidden
                    multiple
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.csv,.txt"
                    onChange={handleRFFileSelect}
                    style={{ display: "none" }}
                  />

                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("rfEvidence");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <Box
                  component="div"
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDrop={handleRFDrop}
                  onClick={() => rfFileInputRef.current.click()}
                  sx={{
                    mt: 2,
                    border: "2px dashed #bdbdbd",
                    borderRadius: "8px",
                    p: 3,
                    backgroundColor: rfDragActive ? "#f5f5f5" : "#fafafa",
                    borderColor: rfDragActive ? "#2196f3" : "#bdbdbd",
                    textAlign: "center",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      borderColor: "#2196f3",
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  <CloudCircleIcon
                    sx={{ fontSize: 48, color: "#bdbdbd", mb: 1 }}
                  />
                  <Typography variant="h6" color="textSecondary" gutterBottom>
                    Drag & Drop Files Here
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    or click to select files
                  </Typography>
                </Box>

                {/* File List */}
                {rfFiles.length > 0 && (
                  <Box sx={{ mt: 2, maxHeight: "150px", overflow: "auto" }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      Uploaded Files ({rfFiles.length})
                    </Typography>
                    <Paper
                      variant="outlined"
                      sx={{ maxHeight: "120px", overflow: "auto" }}
                    >
                      {rfFiles.map((file, index) => (
                        <Box
                          key={file.id || index}
                          onClick={() => handleFileView(file)}
                          sx={{
                            p: 1,
                            display: "flex",
                            alignItems: "center",
                            borderBottom:
                              index < rfFiles.length - 1
                                ? "1px solid #eee"
                                : "none",
                            cursor: "pointer",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              flexGrow: 1,
                            }}
                          >
                            <Box sx={{ mr: 1 }}>
                              {getFileIcon(file.original_filename)}
                            </Box>
                            <Typography variant="body2">
                              {file.original_filename}
                            </Typography>
                          </Box>
                          <Tooltip title="Delete">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveRFFile(file.id);
                              }}
                              sx={{ color: "#757575" }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ))}
                    </Paper>
                  </Box>
                )}
              </Paper>

              <Paper
                sx={{
                  padding: "20px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ width: "100%", mb: 2 }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1">Conclusion</Typography>
                  </Box>
                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("rfConclusion");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>

                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    RF Conclusion Status
                  </Typography>
                  <RadioGroup
                    row
                    value={rfConclusion}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRfConclusion(newValue);
                      handleWorkpaperSave(newValue, "rfConclusion");
                    }}
                  >
                    <FormControlLabel
                      value="Effective"
                      control={<Radio />}
                      label="Effective"
                    />
                    <FormControlLabel
                      value="Not Effective"
                      control={<Radio />}
                      label="Not Effective"
                    />
                    <FormControlLabel
                      value="Inconclusive"
                      control={<Radio />}
                      label="Inconclusive"
                    />
                  </RadioGroup>
                </Box>
              </Paper>
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={{
              mb: 2,
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h6">
                      <PagesIcon sx={{ marginRight: "5px", color: "grey" }} />
                      Final
                    </Typography>
                  </Stack>
                </Box>
                <Switch
                  checked={finalApplicable === "Yes"}
                  onChange={(e) => handleSwitchChange(e, "final")}
                  sx={{ marginLeft: "auto" }}
                />
              </Stack>
            </AccordionSummary>

            <AccordionDetails>
              <Paper sx={{ padding: "20px" }}>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ width: "100%", mb: 2 }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: 1, color: "text.secondary", fontWeight: 500 }}
                    >
                      Test Type
                    </Typography>
                  </Box>
                </Stack>
                <TestTypeSelector
                  value={finalProcedureType}
                  onChange={(newValue) => {
                    setFinalProcedureType(newValue);
                    handleWorkpaperSave(newValue, "finalProcedureType");
                  }}
                />
              </Paper>

              {/* Final Population and Samples */}
              <Paper sx={{ padding: "20px", marginTop: "20px" }}>
                <Typography variant="subtitle1" sx={{ mb: 2, color: "text.secondary" }}>
                  Population and Samples
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Population Size"
                      value={workpaperDetails?.[0]?.FINAL_POPULATION || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setWorkpaperDetails(prev => [{
                          ...prev[0],
                          FINAL_POPULATION: newValue
                        }]);
                        handleWorkpaperSave(newValue, "finalPopulation");
                      }}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Sample Size"
                      value={workpaperDetails?.[0]?.FINAL_SAMPLES || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setWorkpaperDetails(prev => [{
                          ...prev[0],
                          FINAL_SAMPLES: newValue
                        }]);
                        handleWorkpaperSave(newValue, "finalSamples");
                      }}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper
                sx={{ padding: "20px", height: "450px", marginTop: "20px" }}
              >
                <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="subtitle1">
                        Final Procedures
                      </Typography>
                    </Stack>
                  </Box>
                  <Tooltip title="Procedure Library">
                    <IconButton onClick={() => handleOpenModal("final")}>
                      <LibraryBooksIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Generate Test Procedure">
                    <IconButton
                      onClick={() => handleOpenModal("generate", "final")}
                      disabled={isGenerating}
                    >
                      {isGenerating ? (
                        <CircularProgress size={20} />
                      ) : (
                        <AutoAwesomeIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("finalProcedure");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <EditorWithReviewNotes
                  value={finalProcedure}
                  onChange={setFinalProcedure}
                  section="finalProcedure"
                />
              </Paper>

              <Paper
                sx={{ padding: "20px", height: "450px", marginTop: "20px" }}
              >
                <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1">Final Result</Typography>
                  </Box>
                  <Tooltip title="Analyze Result">
                    <IconButton>
                      <TipsAndUpdatesIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("finalResult");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <EditorWithReviewNotes
                  value={finalResult}
                  onChange={setFinalResult}
                  section="finalResult"
                />
              </Paper>

              <Paper
                sx={{ padding: "20px", height: "450px", marginTop: "20px" }}
              >
                <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1">Final Evidence</Typography>
                  </Box>
                  <input
                    type="file"
                    ref={finalFileInputRef}
                    hidden
                    multiple
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.csv,.txt"
                    onChange={handleFinalFileSelect}
                    style={{ display: "none" }}
                  />

                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("finalEvidence");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <Box
                  component="div"
                  onDragOver={handleDragOver}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDrop={handleFinalDrop}
                  onClick={() => finalFileInputRef.current.click()}
                  sx={{
                    mt: 2,
                    border: "2px dashed #bdbdbd",
                    borderRadius: "8px",
                    p: 3,
                    backgroundColor: finalDragActive ? "#f5f5f5" : "#fafafa",
                    borderColor: finalDragActive ? "#2196f3" : "#bdbdbd",
                    textAlign: "center",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      borderColor: "#2196f3",
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  <CloudCircleIcon
                    sx={{ fontSize: 48, color: "#bdbdbd", mb: 1 }}
                  />
                  <Typography variant="h6" color="textSecondary" gutterBottom>
                    Drag & Drop Files Here
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    or click to select files
                  </Typography>
                </Box>

                {/* File List */}
                {finalFiles.length > 0 && (
                  <Box sx={{ mt: 2, maxHeight: "150px", overflow: "auto" }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      Uploaded Files ({finalFiles.length})
                    </Typography>
                    <Paper
                      variant="outlined"
                      sx={{ maxHeight: "120px", overflow: "auto" }}
                    >
                      {finalFiles.map((file, index) => (
                        <Box
                          key={file.id || index}
                          onClick={() => handleFileView(file)}
                          sx={{
                            p: 1,
                            display: "flex",
                            alignItems: "center",
                            borderBottom:
                              index < finalFiles.length - 1
                                ? "1px solid #eee"
                                : "none",
                            cursor: "pointer",
                            "&:hover": {
                              backgroundColor: "#f5f5f5",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              flexGrow: 1,
                            }}
                          >
                            <Box sx={{ mr: 1 }}>
                              {getFileIcon(file.original_filename)}
                            </Box>
                            <Typography variant="body2">
                              {file.original_filename}
                            </Typography>
                          </Box>
                          <Tooltip title="Delete">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveFinalFile(file.id);
                              }}
                              sx={{ color: "#757575" }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ))}
                    </Paper>
                  </Box>
                )}
              </Paper>

              <Paper
                sx={{
                  padding: "20px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{ width: "100%", mb: 2 }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1">Conclusion</Typography>
                  </Box>
                  <Tooltip title="Add Review Notes">
                    <IconButton
                      onClick={() => {
                        setActiveSection("finalConclusion");
                        setShowReviewNotes(true);
                      }}
                    >
                      <ChatBubbleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>

                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Final Conclusion Status
                  </Typography>
                  <RadioGroup
                    row
                    value={finalConclusion}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setFinalConclusion(newValue);
                      handleWorkpaperSave(newValue, "finalConclusion");
                    }}
                  >
                    <FormControlLabel
                      value="Effective"
                      control={<Radio />}
                      label="Effective"
                    />
                    <FormControlLabel
                      value="Not Effective"
                      control={<Radio />}
                      label="Not Effective"
                    />
                    <FormControlLabel
                      value="Inconclusive"
                      control={<Radio />}
                      label="Inconclusive"
                    />
                  </RadioGroup>
                </Box>
              </Paper>
            </AccordionDetails>
          </Accordion>
        </div>
      ),
    },
    {
      value: "4",
      label: <div>Conclusion</div>,
      content: (
        <div>
          <Box sx={{ mb: 4 }}>
            <Paper 
              elevation={0}
              sx={{ 
                padding: "24px",
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
              }}
            >
              <Stack direction="row" spacing={1} sx={{ width: "100%", mb: 3 }} alignItems="center">
                <Typography 
                  variant="subtitle1" 
                  sx={{ 
                    fontWeight: 600,
                    color: 'text.primary',
                    flex: 1
                  }}
                >
                  Testing Summary
                </Typography>
                
              </Stack>
              <Grid container spacing={2}>
                {[
                  { phase: "Design", status: designConclusion || "Not Started", icon: <FactCheckIcon sx={{ fontSize: 20 }} /> },
                  { phase: "Interim", status: interimConclusion || "Not Started", icon: <TimelineOutlinedIcon sx={{ fontSize: 20 }} /> },
                  { phase: "RF", status: rfConclusion || "Not Started", icon: <AutoFixHighIcon sx={{ fontSize: 20 }} /> },
                  { phase: "Final", status: finalConclusion || "Not Started", icon: <AssignmentTurnedInRoundedIcon sx={{ fontSize: 20 }} /> },
                ].map((item) => {
                  const isEffective = item.status.toLowerCase() === "effective";
                  const isNotEffective = item.status.toLowerCase() === "not effective" || item.status.toLowerCase() === "ineffective";
                  const isInProgress = item.status.toLowerCase() === "in progress";
                  
                  return (
                    <Grid item xs={12} sm={6} md={3} key={item.phase}>
                      <Box
                        sx={{
                          p: 2.5,
                          height: '100%',
                          border: '1px solid',
                          borderColor: (theme) => 
                            isEffective ? alpha(theme.palette.success.main, 0.2) :
                            isNotEffective ? alpha(theme.palette.error.main, 0.2) :
                            isInProgress ? alpha(theme.palette.warning.main, 0.2) :
                            theme.palette.divider,
                          borderRadius: 2,
                          backgroundColor: (theme) => 
                            isEffective ? alpha(theme.palette.success.main, 0.02) :
                            isNotEffective ? alpha(theme.palette.error.main, 0.02) :
                            isInProgress ? alpha(theme.palette.warning.main, 0.02) :
                            theme.palette.background.paper,
                          transition: 'all 0.2s ease-in-out',
                          '&:hover': {
                            borderColor: (theme) => 
                              isEffective ? theme.palette.success.main :
                              isNotEffective ? theme.palette.error.main :
                              isInProgress ? theme.palette.warning.main :
                              theme.palette.primary.main,
                            backgroundColor: (theme) => 
                              isEffective ? alpha(theme.palette.success.main, 0.05) :
                              isNotEffective ? alpha(theme.palette.error.main, 0.05) :
                              isInProgress ? alpha(theme.palette.warning.main, 0.05) :
                              alpha(theme.palette.primary.main, 0.02),
                          }
                        }}
                      >
                        <Stack spacing={2}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Box sx={{ 
                              color: (theme) =>
                                isEffective ? theme.palette.success.main :
                                isNotEffective ? theme.palette.error.main :
                                isInProgress ? theme.palette.warning.main :
                                alpha(theme.palette.text.secondary, 0.7)
                            }}>
                              {item.icon}
                            </Box>
                            <Typography 
                              variant="subtitle2" 
                              sx={{ 
                                fontWeight: 600,
                                color: 'text.primary',
                              }}
                            >
                              {item.phase}
                            </Typography>
                          </Stack>
                          <Stack direction="row" alignItems="center" spacing={1.5}>
                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: (theme) =>
                                  isEffective ? theme.palette.success.main :
                                  isNotEffective ? theme.palette.error.main :
                                  isInProgress ? theme.palette.warning.main :
                                  theme.palette.grey[300],
                                boxShadow: (theme) =>
                                  isEffective ? `0 0 0 3px ${alpha(theme.palette.success.main, 0.12)}` :
                                  isNotEffective ? `0 0 0 3px ${alpha(theme.palette.error.main, 0.12)}` :
                                  isInProgress ? `0 0 0 3px ${alpha(theme.palette.warning.main, 0.12)}` :
                                  'none',
                              }}
                            />
                            <Typography 
                              variant="body2"
                              sx={{ 
                                fontWeight: 500,
                                color: (theme) =>
                                  isEffective ? theme.palette.success.main :
                                  isNotEffective ? theme.palette.error.main :
                                  isInProgress ? theme.palette.warning.main :
                                  theme.palette.text.secondary,
                              }}
                            >
                              {item.status}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </Paper>
          </Box>
          {[
            designConclusion,
            interimConclusion,
            rfConclusion,
            finalConclusion,
          ].some(
            (conclusion) => conclusion?.toLowerCase() === "not effective"
          ) && (
            <>
              <Typography
                variant="subtitle1"
                sx={{ mb: 2, fontWeight: "bold" }}
              >
                Deficiency Details
              </Typography>
              <Box sx={{ height: "calc(100% - 160px)", overflow: "auto" }}>
                <Stack spacing={3}>
                  <Box>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">Type</Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setActiveSection("deficiency_type");
                          setShowReviewNotes(true);
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                    <NormalTextField
                      value={deficiencyType}
                      onChange={(e) =>
                        handleWorkpaperSave(e.target.value, "deficiency_type")
                      }
                      fullWidth
                    />
                  </Box>

                  <Box>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">Description</Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setActiveSection("deficiency_description");
                          setShowReviewNotes(true);
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                    <EditorWithReviewNotes
                      value={deficiencyDescription}
                      onChange={(value) =>
                        handleWorkpaperSave(value, "deficiency_description")
                      }
                      section="deficiency_description"
                    />
                  </Box>

                  <Box>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">Date Identified</Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setActiveSection("date_identified");
                          setShowReviewNotes(true);
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                    <NormalTextField
                      type="date"
                      value={dateIdentified}
                      onChange={(e) =>
                        handleWorkpaperSave(e.target.value, "date_identified")
                      }
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </Box>

                  <Box>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">Root Cause</Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setActiveSection("root_cause");
                          setShowReviewNotes(true);
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                    <EditorWithReviewNotes
                      value={rootCause}
                      onChange={(value) =>
                        handleWorkpaperSave(value, "root_cause")
                      }
                      section="root_cause"
                    />
                  </Box>

                  <Box>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">Management Action Plan</Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setActiveSection("management_action_plan");
                          setShowReviewNotes(true);
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                    <EditorWithReviewNotes
                      value={managementActionPlan}
                      onChange={(value) =>
                        handleWorkpaperSave(value, "management_action_plan")
                      }
                      section="management_action_plan"
                    />
                  </Box>

                  <Box>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">Remediation Owner</Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setActiveSection("remediation_owner");
                          setShowReviewNotes(true);
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                    <MultipleSelect
                      isMultiSelect={false}
                      defaultValue={employeeOptions.find(opt => opt.value === remediationOwner)}
                      placeholderText="Select remediation owner..."
                      selectOptions={employeeOptions}
                      selectedOptions={employeeOptions.find(opt => opt.value === remediationOwner)}
                      handleChange={(selected) => {
                        if (selected) {
                          handleWorkpaperSave(selected.value, "remediation_owner");
                        }
                      }}
                    />
                  </Box>

                  <Box>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">Remediation Status</Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setActiveSection("remediation_status");
                          setShowReviewNotes(true);
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                    <RadioGroup
                      row
                      value={remediationStatus}
                      onChange={(e) => {
                        handleWorkpaperSave(e.target.value, "remediation_status");
                      }}
                    >
                      <FormControlLabel
                        value="Remediated"
                        control={<Radio />}
                        label="Remediated"
                      />
                      <FormControlLabel
                        value="Unremediated"
                        control={<Radio />}
                        label="Unremediated"
                      />
                    </RadioGroup>
                  </Box>

                  <Box>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">Date Closed</Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setActiveSection("date_closed");
                          setShowReviewNotes(true);
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                    <NormalTextField
                      type="date"
                      value={dateClosed}
                      onChange={(e) =>
                        handleWorkpaperSave(e.target.value, "date_closed")
                      }
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                    />
                  </Box>

                  <Box>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">Mitigating Controls</Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setActiveSection("mitigating_controls");
                          setShowReviewNotes(true);
                        }}
                      >
                        <ChatBubbleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                    <EditorWithReviewNotes
                      value={mitigatingControls}
                      onChange={(value) =>
                        handleWorkpaperSave(value, "mitigating_controls")
                      }
                      section="mitigating_controls"
                    />
                  </Box>
                </Stack>
              </Box>
            </>
          )}
        </div>
      ),
    },
    {
      value: "5",
      label: <div>Evidences</div>,
      content: (
        <div>
         <WorkpapersEvidence projectID={selectedProject.id} workpaperId={testingInfo?.id} />
        </div>
      ),
    },
  ];

  const customMainContent = (
    <div>
      <ResponsiveContainer>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/dashboard">
            <i className="material-icons">home</i>
          </Link>
          <Link underline="hover" color="inherit" href="/dashboard">
            My Dashboard
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href={`/Audit/Projects/${selectedProject.id}`}
          >
            {selectedProject.AUDIT_NAME}
          </Link>
          <Typography color="text.primary">{selectedApp.APP_NAME}</Typography>
          <Link
            underline="hover"
            color="inherit"
            href={`/Audit/Workpapers/${selectedProject.id}`}
          >
            Workpapers
          </Link>
          <Typography color="text.primary">
            {testingInfo?.CONTROL_DETAILS?.CONTROL_ID} -{" "}
            {testingInfo?.CONTROL_DETAILS?.CONTROL_TITLE}
          </Typography>
        </Breadcrumbs>

        <SearchAppBar
          title={`${
            testingInfo?.CONTROL_DETAILS?.CONTROL_ID || "Loading ID"
          } / ${
            testingInfo?.CONTROL_DETAILS?.CONTROL_TITLE || "Loading Title"
          }`}
          icon={<PostAddOutlinedIcon />}
        />
        <Separator />

        {isLoading ? (
          renderLoadingState()
        ) : (
          <Box
            sx={{
              backgroundColor: "whitesmoke",
              minHeight: "80vh",
              padding: "20px",
            }}
          >
            <Grid
              container
              spacing={3}
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid
                item
                xs={12}
                sx={{
                  transition: "margin-left 0.3s ease",
                  marginLeft: sidebarVisible ? 0 : 3,
                }}
              >
                <Paper sx={{ padding: "20px" }}>
                  <Stack direction="row" spacing={1}>
                    <Box sx={{ flexGrow: 1 }}>
                      <Stack direction="row" spacing={1}>
                        <Stack direction="row" spacing={1}>
                          <Chip
                            avatar={
                              <Tooltip title={testingInfo?.ASSIGNED_TO ? 
                                `Assigned to: ${auditUsers.find(user => user.email === testingInfo.ASSIGNED_TO)?.fullName || testingInfo.ASSIGNED_TO}`
                                : "Not Assigned"
                              }>
                                <Avatar
                                  sx={{
                                    bgcolor: getStatusColor(workpaperStatus),
                                    width: 24,
                                    height: 24,
                                    position: 'relative',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  {testingInfo?.ASSIGNED_TO ? (
                                    <Typography 
                                      variant="caption" 
                                      sx={{ 
                                        fontWeight: 600,
                                        fontSize: '0.75rem',
                                        color: 'white'
                                      }}
                                    >
                                      {getInitials(testingInfo.ASSIGNED_TO)}
                                    </Typography>
                                  ) : (
                                    getStatusIcon(workpaperStatus, "white")
                                  )}
                                </Avatar>
                              </Tooltip>
                            }
                            label={workpaperStatus}
                            variant="outlined"
                            sx={{
                              marginLeft: "auto",
                              padding: "4px 8px",
                              borderRadius: "16px",
                              cursor: "pointer",
                              borderColor: getStatusColor(workpaperStatus),
                              color: getStatusColor(workpaperStatus),
                              "&:hover": {
                                borderColor: getStatusColor(workpaperStatus),
                                bgcolor: `${getStatusColor(workpaperStatus)}10`,
                              },
                            }}
                            onClick={handleStatusClick}
                          />
                          <Menu
                            anchorEl={statusAnchorEl}
                            open={Boolean(statusAnchorEl)}
                            onClose={handleStatusClose}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            PaperProps={{
                              sx: {
                                minWidth: 200,
                                mt: 1,
                              },
                            }}
                          >
                            {statusOptions.map((status) => (
                              <MenuItem
                                key={status}
                                onClick={() => handleStatusChange(status)}
                                selected={workpaperStatus === status}
                                sx={{
                                  color:
                                    workpaperStatus === status
                                      ? "#2196f3"
                                      : "#757575",
                                  "&.Mui-selected": {
                                    bgcolor: "#2196f320",
                                    "&:hover": {
                                      bgcolor: "#2196f330",
                                    },
                                  },
                                }}
                              >
                                <ListItemIcon>
                                  {getStatusIcon(status)}
                                </ListItemIcon>
                                <ListItemText primary={status} />
                              </MenuItem>
                            ))}
                          </Menu>
                        </Stack>
                        <Stack direction="row" spacing={1}>
                          <SignOffStatus workpaperDetails={workpaperDetails} />
                          
                        </Stack>
                      </Stack>
                    </Box>

                    <WorkpaperExport 
                      testingInfo={testingInfo}
                      workpaperDetails={workpaperDetails}
                      designFiles={uploadedFiles}
                      interimFiles={interimFiles}
                      rfFiles={rfFiles}
                      finalFiles={finalFiles}
                    />
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Chip
                        icon={<HistoryEduIcon />}
                        label="Sign-Off"
                        onClick={handleSignOffClick}
                        color="primary"
                        variant="outlined"
                        sx={{
                          padding: "4px 8px",
                          borderRadius: "16px",
                          borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
                          '&:hover': {
                            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04),
                            borderColor: 'primary.main'
                          }
                        }}
                      />
                      <Chip
                        icon={<SpeakerNotesOutlinedIcon />}
                        onClick={() => {
                          setShowReviewNotes(true);
                        }}
                        color="primary"
                        label={`Notes ${
                          reviewNotes.filter((note) => !note.resolved).length > 0
                            ? `(${
                                reviewNotes.filter((note) => !note.resolved)
                                  .length
                              })`
                            : ""
                        }`}
                        variant="outlined"
                        sx={{
                          borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
                          padding: "4px 8px",
                          borderRadius: "16px",
                          '&:hover': {
                            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04),
                            borderColor: 'primary.main'
                          },
                          "& .MuiChip-label": {
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }
                        }}
                      />
                      <Chip
                        icon={<SendIcon sx={{ fontSize: "18px" }} />}
                        onClick={() => setAssignDialogOpen(true)}
                        color="primary"
                        label="Assign"
                        variant="outlined"
                        sx={{
                          borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
                          padding: "4px 8px",
                          borderRadius: "16px",
                          '&:hover': {
                            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.04),
                            borderColor: 'primary.main'
                          }
                        }}
                      />
                    </Stack>
                    <WorkpaperAssignDialog
                      open={assignDialogOpen}
                      onClose={() => setAssignDialogOpen(false)}
                      onAssign={handleAssignWorkpaper}
                      auditUsers={auditUsers}
                      currentAssignee={testingInfo?.ASSIGNED_TO}
                      isAssigning={isAssigning}
                    />
                  </Stack>

                  <Divider sx={{ marginTop: "10px" }} />

                  <DynamicTabs tabs={tabs} />
                </Paper>
              </Grid>
            </Grid>
          </Box>
        )}

        <Modal
          open={openModal}
          onClose={handleCloseModal}
          header="Test Procedures Library"
          size="lg"
          body={
            <>
              <Divider />
              <Box sx={{ overflow: "auto" }}>
                <div
                  style={{
                    marginTop: "10px",
                    marginBottom: "18px",
                    position: "relative",
                  }}
                >
                  <label
                    style={{
                      display: "block",
                      width: "80px",
                      marginLeft: "10px",
                      zIndex: "1000000",
                      marginBottom: "-10px",
                      fontSize: "12px",
                      position: "relative",
                      backgroundColor: "white",
                      padding: "0px 5px",
                      color: "grey",
                    }}
                  >
                    Control
                  </label>
                  <div
                    style={{
                      marginBottom: "18px",
                      position: "relative",
                      zIndex: "99999",
                    }}
                  >
                    <MultipleSelect
                      zIndex="99999"
                      isMultiSelect={false}
                      defaultValue={selectedControl}
                      placeholderText="Select a control..."
                      selectOptions={controlOptions}
                      selectedOptions={selectedControl}
                      handleChange={handleControlChange}
                    />
                  </div>
                </div>

                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                  <Tabs
                    value={modalTabValue}
                    onChange={(e, newValue) => setModalTabValue(newValue)}
                    variant="fullWidth"
                  >
                    <Tab label="Design" value="design" />
                    <Tab label="Interim" value="interim" />
                    <Tab label="Roll Forward" value="rollforward" />
                    <Tab label="Final" value="final" />
                  </Tabs>
                </Box>

                {modalTabValue === "design" && (
                  <Box>
                    <Editor
                      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                      value={modalProceduresData.DESIGN_PROCEDURES}
                      onEditorChange={(content) => {
                        setModalProceduresData((prev) => ({
                          ...prev,
                          DESIGN_PROCEDURES: content,
                        }));
                      }}
                      init={{
                        height: 400,
                        menubar: false,
                        statusbar: false,
                        branding: false,
                        elementpath: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "charmap",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "insertdatetime",
                          "table",
                          "textcolor",
                        ],
                        toolbar:
                          "formatselect | " +
                          "bold italic forecolor | alignleft aligncenter " +
                          "alignright alignjustify | bullist numlist | " +
                          "removeformat",
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        placeholder: "Enter design procedures here...",
                      }}
                    />
                  </Box>
                )}

                {modalTabValue === "interim" && (
                  <Box>
                    <Editor
                      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                      value={modalProceduresData.INTERIM_PROCEDURES}
                      onEditorChange={(content) => {
                        setModalProceduresData((prev) => ({
                          ...prev,
                          INTERIM_PROCEDURES: content,
                        }));
                      }}
                      init={{
                        height: 400,
                        menubar: false,
                        statusbar: false,
                        branding: false,
                        elementpath: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "charmap",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "insertdatetime",
                          "table",
                          "textcolor",
                        ],
                        toolbar:
                          "formatselect | " +
                          "bold italic forecolor | alignleft aligncenter " +
                          "alignright alignjustify | bullist numlist | " +
                          "removeformat",
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        placeholder: "Enter interim procedures here...",
                      }}
                    />
                  </Box>
                )}

                {modalTabValue === "rollforward" && (
                  <Box>
                    <Editor
                      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                      value={modalProceduresData.ROLLFORWARD_PROCEDURES}
                      onEditorChange={(content) => {
                        setModalProceduresData((prev) => ({
                          ...prev,
                          ROLLFORWARD_PROCEDURES: content,
                        }));
                      }}
                      init={{
                        height: 400,
                        menubar: false,
                        statusbar: false,
                        branding: false,
                        elementpath: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "charmap",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "insertdatetime",
                          "table",
                          "textcolor",
                        ],
                        toolbar:
                          "formatselect | " +
                          "bold italic forecolor | alignleft aligncenter " +
                          "alignright alignjustify | bullist numlist | " +
                          "removeformat",
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        placeholder: "Enter roll forward procedures here...",
                      }}
                    />
                  </Box>
                )}

                {modalTabValue === "final" && (
                  <Box>
                    <Editor
                      apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                      value={modalProceduresData.FINAL_PROCEDURES}
                      onEditorChange={(content) => {
                        setModalProceduresData((prev) => ({
                          ...prev,
                          FINAL_PROCEDURES: content,
                        }));
                      }}
                      init={{
                        height: 400,
                        menubar: false,
                        statusbar: false,
                        branding: false,
                        elementpath: false,
                        plugins: [
                          "advlist",
                          "autolink",
                          "lists",
                          "link",
                          "charmap",
                          "anchor",
                          "searchreplace",
                          "visualblocks",
                          "insertdatetime",
                          "table",
                          "textcolor",
                        ],
                        toolbar:
                          "formatselect | " +
                          "bold italic forecolor | alignleft aligncenter " +
                          "alignright alignjustify | bullist numlist | " +
                          "removeformat",
                        content_style:
                          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                        placeholder: "Enter final procedures here...",
                      }}
                    />
                  </Box>
                )}
              </Box>
            </>
          }
          footer={
            <>
              <Button
                sx={{ marginBottom: "10px" }}
                onClick={handleCloseModal}
                variant="outlined"
                color="primary"
              >
                Cancel
              </Button>
              <Button
                sx={{ marginBottom: "10px", marginRight: "10px" }}
                onClick={handleUseProcedure}
                variant="contained"
                color="primary"
              >
                Use{" "}
                {modalTabValue.charAt(0).toUpperCase() + modalTabValue.slice(1)}{" "}
                Procedure
              </Button>
            </>
          }
        />
      </ResponsiveContainer>
    </div>
  );

  // Add new state for generating procedures
  const [currentProcedureType, setCurrentProcedureType] = useState("design");

  // Add new function for generating procedures
  const generateProcedure = async (type) => {
    setIsGenerating(true);
    try {
      const response = await auditService.generateTestProcedure({
        control_title: testingInfo?.CONTROL_DETAILS?.CONTROL_TITLE,
        procedure_type: type,
      });

      if (response.procedure) {
        switch (type) {
          case "design":
            setDesignProcedure(response.procedure);
            handleWorkpaperSave(response.procedure, "designProcedure");
            break;
          case "interim":
            setInterimProcedure(response.procedure);
            handleWorkpaperSave(response.procedure, "interimProcedure");
            break;
          case "rollforward":
            setRfProcedure(response.procedure);
            handleWorkpaperSave(response.procedure, "rfProcedure");
            break;
          case "final":
            setFinalProcedure(response.procedure);
            handleWorkpaperSave(response.procedure, "finalProcedure");
            break;
        }

        setSnackbarMessage("Procedure generated successfully");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error generating procedure:", error);
      setSnackbarMessage("Failed to generate procedure");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setIsGenerating(false);
    }
  };

  // Add snackbar close handler
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleGenerateConfirm = () => {
    setShowGenerateConfirmation(false);
    // Use the stored procedure type for generation
    generateProcedure(currentProcedureType);
  };

  const handleGenerateCancel = () => {
    setShowGenerateConfirmation(false);
  };

  // Add this component for the loading animation
  const LoadingSpinner = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        gap: 2
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: 'primary.main',
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          }
        }}
      />
      <Typography
        variant="h6"
        sx={{
          color: 'text.secondary',
          fontWeight: 500,
          textAlign: 'center',
          animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
          '@keyframes pulse': {
            '0%, 100%': {
              opacity: 1,
            },
            '50%': {
              opacity: 0.7,
            },
          },
        }}
      >
        Generating Documentation...
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ textAlign: 'center', maxWidth: 400 }}
      >
        Our AI is analyzing your inputs and crafting detailed documentation. This may take a few moments.
      </Typography>
    </Box>
  );

  // Add new state for employee options


  // Add useEffect to fetch active employees
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const employees = await HRService.fetchActiveEmployees();
        setEmployeeOptions(employees);
      } catch (error) {
        console.error('Error fetching active employees:', error);
      }
    };
    fetchEmployees();
  }, []);

  // Add new state variables for sign-of

  // Add sign-off handlers
  

  // Add sign-off dialog component
  const SignOffDialog = () => (
    <Dialog 
      open={signOffDialogOpen} 
      onClose={handleSignOffDialogClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          width: '400px',
          bgcolor: 'background.paper',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          overflow: 'hidden'
        }
      }}
    >
      <Box sx={{ p: 3, pb: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <AssignmentTurnedInRoundedIcon sx={{ color: 'primary.main', fontSize: 24 }} />
          <DialogTitle sx={{ 
            p: 0,
            fontSize: '1.25rem',
            fontWeight: 600,
            color: 'text.primary',
            letterSpacing: '-0.01em'
          }}>
            Workpaper Sign-Off
          </DialogTitle>
        </Stack>
      </Box>

      <DialogContent sx={{ p: 3 }}>
        <DialogContentText sx={{ 
          color: 'text.secondary',
          fontSize: '0.95rem',
          lineHeight: 1.6,
          mb: 2
        }}>
          Select the phase and your role to sign off this workpaper.
        </DialogContentText>
        
        <Stack spacing={2.5}>
          <FormControl>
            <InputLabel sx={{ 
              fontSize: '0.875rem',
              color: 'text.secondary'
            }}>Phase</InputLabel>
            <Select
              value={signOffPhase}
              onChange={(e) => setSignOffPhase(e.target.value)}
              label="Phase"
              size="small"
              sx={{
                '& .MuiSelect-select': {
                  fontSize: '0.875rem',
                  py: 1.25
                }
              }}
            >
              <MenuItem value="DESIGN" sx={{ fontSize: '0.875rem' }}>Design</MenuItem>
              <MenuItem value="INTERIM" sx={{ fontSize: '0.875rem' }}>Interim</MenuItem>
              <MenuItem value="RF" sx={{ fontSize: '0.875rem' }}>Rollforward</MenuItem>
              <MenuItem value="FINAL" sx={{ fontSize: '0.875rem' }}>Final</MenuItem>
            </Select>
          </FormControl>

          <FormControl>
            <InputLabel sx={{ 
              fontSize: '0.875rem',
              color: 'text.secondary'
            }}>Role</InputLabel>
            <Select
              value={signOffRole}
              onChange={(e) => setSignOffRole(e.target.value)}
              label="Role"
              size="small"
              sx={{
                '& .MuiSelect-select': {
                  fontSize: '0.875rem',
                  py: 1.25
                }
              }}
            >
              <MenuItem value="Tester" sx={{ fontSize: '0.875rem' }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem', bgcolor: 'primary.main' }}>T</Avatar>
                  <span>Tester</span>
                </Stack>
              </MenuItem>
              <MenuItem value="Reviewer" sx={{ fontSize: '0.875rem' }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Avatar sx={{ width: 24, height: 24, fontSize: '0.75rem', bgcolor: 'secondary.main' }}>R</Avatar>
                  <span>Reviewer</span>
                </Stack>
              </MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Button 
          onClick={handleSignOffDialogClose}
          sx={{ 
            color: 'text.secondary',
            fontWeight: 500,
            px: 2,
            '&:hover': {
              backgroundColor: alpha('#000', 0.04)
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleSignOffSubmit} 
          disabled={!signOffRole || !signOffPhase}
          variant="contained"
          startIcon={<AssignmentTurnedInRoundedIcon />}
          sx={{ 
            bgcolor: 'primary.main',
            fontWeight: 500,
            px: 2,
            '&:hover': {
              bgcolor: 'primary.dark'
            },
            boxShadow: 'none',
            textTransform: 'none'
          }}
        >
          Sign Off
        </Button>
      </DialogActions>
    </Dialog>
  );

  // Add function to get sign-off status icons for any phase


  const handleAssignmentChange = async (field, value) => {
    try {
      // Check for duplicate assignments in the same phase
      const checkDuplicateAssignment = (phase, role, email) => {
        switch (phase) {
          case 'design':
            return (role === 'tester' && email === designReviewer) || 
                   (role === 'reviewer' && email === designTester);
          case 'interim':
            return (role === 'tester' && email === interimReviewer) || 
                   (role === 'reviewer' && email === interimTester);
          case 'rf':
            return (role === 'tester' && email === rfReviewer) || 
                   (role === 'reviewer' && email === rfTester);
          case 'final':
            return (role === 'tester' && email === finalReviewer) || 
                   (role === 'reviewer' && email === finalTester);
          default:
            return false;
        }
      };

      // Determine phase and role from field name
      const [phase, role] = field.replace('Tester', '/tester').replace('Reviewer', '/reviewer').split('/');
      
      // Check if this would create a duplicate assignment
      if (checkDuplicateAssignment(phase, role, value)) {
        setSnackbarMessage('The same person cannot be both tester and reviewer in the same phase');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        return;
      }

      // Update local state with the email value
      switch (field) {
        case 'designTester':
          setDesignTester(value);
          break;
        case 'designReviewer':
          setDesignReviewer(value);
          break;
        case 'interimTester':
          setInterimTester(value);
          break;
        case 'interimReviewer':
          setInterimReviewer(value);
          break;
        case 'rfTester':
          setRfTester(value);
          break;
        case 'rfReviewer':
          setRfReviewer(value);
          break;
        case 'finalTester':
          setFinalTester(value);
          break;
        case 'finalReviewer':
          setFinalReviewer(value);
          break;
      }

      // Map the field names to API field names
      const fieldMapping = {
        'designTester': 'DESIGN_TESTER',
        'designReviewer': 'DESIGN_REVIEWER',
        'interimTester': 'INTERIM_TESTER',
        'interimReviewer': 'INTERIM_REVIEWER',
        'rfTester': 'RF_TESTER',
        'rfReviewer': 'RF_REVIEWER',
        'finalTester': 'FINAL_TESTER',
        'finalReviewer': 'FINAL_REVIEWER'
      };

      // Send just the email to the backend
      const data = {
        AUDIT_FILE: testingInfo.id,
        [fieldMapping[field]]: value // value is already the email address from the Select component
      };

      if (workpaperDetailsExisting) {
        await auditService.updateWorkpaperDetails(workpaperID, data);
        
        // Refresh workpaper details to ensure we have the latest data
        const updatedDetails = await auditService.fetchWorkpaperDetailsById(testingInfo.id);
        if (updatedDetails && updatedDetails.length > 0) {
          setWorkpaperDetails(updatedDetails);
          
          // Update all states with the email values
          setDesignTester(updatedDetails[0].DESIGN_TESTER || "");
          setDesignReviewer(updatedDetails[0].DESIGN_REVIEWER || "");
          setInterimTester(updatedDetails[0].INTERIM_TESTER || "");
          setInterimReviewer(updatedDetails[0].INTERIM_REVIEWER || "");
          setRfTester(updatedDetails[0].RF_TESTER || "");
          setRfReviewer(updatedDetails[0].RF_REVIEWER || "");
          setFinalTester(updatedDetails[0].FINAL_TESTER || "");
          setFinalReviewer(updatedDetails[0].FINAL_REVIEWER || "");
        }
      }

      // Show success message
      setSnackbarMessage('Assignment updated successfully');
      setSnackbarSeverity('success');
      setSnackbarOpen(true);
    } catch (error) {
      console.error('Error updating assignment:', error);
      setSnackbarMessage('Error updating assignment');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    }
  };

 



  return (
    <Suspense fallback="Loading...">
      <div>
        <IASideBar mainContent={customMainContent} />
        {showReviewNotes && (
          <ReviewNotesPanel
            section={activeSection}
            setReviewNotes={setReviewNotes}
          />
        )}
        <DynamicSnackbar
          open={snackbarOpen}
          message={snackbarMessage}
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        />
        <AIDocumentationDialog
          open={openAIDialog}
          onClose={handleCloseAIDialog}
          onSubmit={handleSubmitAIDialog}
          processOwners={processOwners}
          setProcessOwners={setProcessOwners}
          dateOfInquiry={dateOfInquiry}
          setDateOfInquiry={setDateOfInquiry}
          policyAvailable={policyAvailable}
          setPolicyAvailable={setPolicyAvailable}
          evidenceReviewed={evidenceTypes}
          setEvidenceReviewed={setEvidenceTypes}
          evidenceDetails={evidenceDetails}
          setEvidenceDetails={setEvidenceDetails}
          evidenceSufficient={evidenceSufficient}
          setEvidenceSufficient={setEvidenceSufficient}
          sampleReviewed={sampleReviewed}
          setSampleReviewed={setSampleReviewed}
          sampleCount={sampleCount}
          setSampleCount={setSampleCount}
          isGenerating={isGenerating}
        />
      </div>
      <AnalysisModal />
      <ConfirmProcedureDialog />
      <Dialog
        open={showGenerateConfirmation}
        onClose={handleGenerateCancel}
        PaperProps={{
          sx: {
            borderRadius: 2,
            width: "400px",
            bgcolor: "background.paper",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            p: 3,
            pb: 1,
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <AutoAwesomeIcon
              sx={{
                color: "primary.main",
                fontSize: 24,
              }}
            />
            <DialogTitle
              sx={{
                p: 0,
                fontSize: "1.25rem",
                fontWeight: 600,
                color: "text.primary",
                letterSpacing: "-0.01em",
              }}
            >
              Generate New Test Procedure
            </DialogTitle>
          </Stack>
        </Box>
        <DialogContent sx={{ p: 3 }}>
          <DialogContentText
            sx={{
              color: "text.secondary",
              fontSize: "0.95rem",
              lineHeight: 1.6,
              mb: 1,
            }}
          >
            You are about to generate a new {currentProcedureType} test
            procedure. This action will replace the existing procedure and
            cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions
          sx={{
            px: 3,
            pb: 3,
            pt: 1,
          }}
        >
          <Button
            onClick={handleGenerateCancel}
            sx={{
              color: "text.secondary",
              fontWeight: 500,
              px: 2,
              "&:hover": {
                backgroundColor: alpha("#000", 0.04),
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleGenerateConfirm}
            variant="contained"
            startIcon={<AutoAwesomeIcon />}
            sx={{
              bgcolor: "primary.main",
              fontWeight: 500,
              px: 2,
              "&:hover": {
                bgcolor: "primary.dark",
              },
              boxShadow: "none",
              textTransform: "none",
            }}
          >
            Generate New Procedure
          </Button>
        </DialogActions>
      </Dialog>
      {SignOffDialog()}
      <WorkpaperAssignDialog
        open={assignDialogOpen}
        onClose={() => setAssignDialogOpen(false)}
        onAssign={handleAssignWorkpaper}
        auditUsers={auditUsers}
        currentAssignee={testingInfo?.ASSIGNED_TO}
        isAssigning={isAssigning}
      />
    </Suspense>
  );
};

export default WorkpapersDetails;
